/* eslint-disable */
/* ==================================================
#Image functions
#Recently viewed
#Load more / infinite load
#Filter products with AJAX
#Predictive search
#Mobile search
#Site overlay
#Sidebar filter on collection pages
#Misc
#Quick shop
#Back to top button
#Newsletter popup
#Product Media Controls
#Plyr setup

/*============================================================================
  #Image functions
==============================================================================*/

window.SEARCH_DEBOUNCE_TIME = 250;
window.usePageDots = window.PXUTheme.theme_settings.page_dots_enabled;

 window.imageFunctions = {
  zoom: function($image) {
    var $image = $image && $image[0] ? $image : $(event.target);
    var zoomSrc = $image.data('zoom-src');

    if (zoomSrc) {
      $image.wrap('<span class="zoom-container"></span>').css('display', 'block').parent().zoom({
        url: zoomSrc,
        touch: false,
        magnify: 1
      });
    }
  },
  linkGalleryAndCarousel: function($gallery, $carousel){

    $carousel.find('.gallery-cell:nth-child(1)').addClass('is-nav-selected');

    //EVENT - click on carousel item to slide gallery
    $carousel.on( 'click', '.gallery-cell', function() {
        var index = $(this).index();
        $carousel.find('.is-nav-selected').removeClass('is-nav-selected');
        $(this).addClass('is-nav-selected');
        $gallery.flickity( 'select', index );
    });

    //EVENT - update carousel based on gallery index
    $gallery.on( 'select.flickity', function() {
      var galleryData = $(this).data('flickity');
      if (galleryData){
        $carousel.find('.is-nav-selected').removeClass('is-nav-selected');
        $carousel.find('.gallery-cell:nth-child(' + (galleryData.selectedIndex + 1) + ')').addClass('is-nav-selected');
      }
    });
  },
  fullWidth: function(images, imageContainer){
    $(images).each(function(){
      var $image = $(this),
          alt = $image.attr('alt'),
          src = $image.attr('src');

      if (alt.indexOf("[") >= 0){

        //remove from description
        $image.remove();

        //find shortcode values and remove from alt
        var shortcodes = alt.match(/\[(.*?)\]/ig);
        alt = alt.replace(/\[(.*?)\]/ig, '');

        //remove brackets from shortcode to be used as classes
        var captionClass = $.map( shortcodes, function( value, index ) {
            value = value.replace(/[\[\]']+/g,'');
            return value;
        });

        //markup for caption

        var caption = [
            '<div class="position-' + (captionClass.length ? captionClass : 'center') + ' caption js-caption">',
              '<div class="caption-content caption-background-false align-' + (captionClass.length ? captionClass : 'center') + '">',
                '<p class="headline">' + alt + '</p>',
              '</div>',
            '</div>'
        ].join('');

        //image attributes added
        $image.attr({
          alt: alt,
          class: 'lazyload color',
          src: src,
          dataSizes: 'auto'
        });

        var image = $image.prop('outerHTML')
        var banner =  '<div class="banner">' + image + caption + '</div>'

        $(imageContainer).append(banner);
      }
    })
  },
  showSecondaryImage: function(){
    if (window.PXUTheme.media_queries.large.matches) {
      $('.has-secondary-media-swap').off().on('mouseenter', function() {
        if (window.PXUTheme.theme_settings.product_form_style == 'select') {
          $(this).find('.product_gallery').toggleClass('secondary-media-hidden');
        }
        $(this).find('.image-element__wrap img').toggleClass('secondary-media-hidden');
        $(this).find('[data-html5-video]').toggleClass('secondary-media-hidden');
        $(this).find('.external-video__container').toggleClass('secondary-media-hidden');
        window.videoFeature.enableVideoOnHover($(this));
      });

      $('.has-secondary-media-swap').on('mouseleave', function() {
        if (window.PXUTheme.theme_settings.product_form_style == 'select') {
          $(this).find('.product_gallery').toggleClass('secondary-media-hidden');
        }
        $(this).find('.image-element__wrap img').toggleClass('secondary-media-hidden');
        $(this).find('[data-html5-video]').toggleClass('secondary-media-hidden');
        $(this).find('.external-video__container').toggleClass('secondary-media-hidden');
        window.videoFeature.enableVideoOnHover($(this));
      });
    }
  },
  //Fix for flickity issue on IOS, where you can't swipe through the slider
  flickityIosFix: function()  {
    var touchingCarousel = false,
      touchStartCoords;

    document.body.addEventListener('touchstart', function(e) {
      if (e.target.closest('.flickity-slider')) {
        touchingCarousel = true;
      } else {
        touchingCarousel = false;
        return;
      }

      touchStartCoords = {
        x: e.touches[0].pageX,
        y: e.touches[0].pageY
      }
    });

    document.body.addEventListener('touchmove', function(e) {
      if (!(touchingCarousel && e.cancelable)) {
        return;
      }

      var moveVector = {
        x: e.touches[0].pageX - touchStartCoords.x,
        y: e.touches[0].pageY - touchStartCoords.y
      };

      if (Math.abs(moveVector.x) > 7)
        e.preventDefault()

    }, {passive: false});
  }
}

/* ============================================================================
  #Recently viewed
============================================================================== */

window.recentlyViewed = {
  init() {
    let productHandle;
    let rvCookie;
    let rvProducts;
    let displayProducts;
    let rvProductArray;

    if ($('.js-product-section[data-rv-handle]').length) {
      productHandle = $('.js-product-section').data('rv-handle').toString();
      rvCookie = window.Cookies.get('recentlyViewed');
      rvProducts = window.recentlyViewed.getCookieProducts(rvCookie, productHandle);
    } else if ($('.recently-viewed__section').length) {
      rvCookie = window.Cookies.get('recentlyViewed');
      rvProducts = window.recentlyViewed.getCookieProducts(rvCookie, productHandle);
    } else if ($('.js-sidebar-recently-viewed').length) {
      rvCookie = window.Cookies.get('recentlyViewed');
      rvProducts = window.recentlyViewed.getCookieProducts(rvCookie, productHandle);
    }

    if (rvProducts) {
      rvProductArray = unescape(rvProducts).split(',');
    }

    if (productHandle) {
      if (!$.inArray(productHandle, rvProductArray) !== -1) {
        displayProducts = [];
        rvProductArray.unshift(productHandle);
        $.each(rvProductArray, (_i, el) => {
          if ($.inArray(el, displayProducts) === -1) displayProducts.push(el);
        });
      }

      window.recentlyViewed.setCookieProducts(displayProducts);
    } else {
      displayProducts = rvProductArray;
    }

    if ($('.recently-viewed__section').length) {
      const parent = '.recently-viewed__section';
      const recentlyViewedProductsLoaded = $(parent).data('recently-viewed-items-loaded');

      if (recentlyViewedProductsLoaded) {
        return false;
      }

      window.recentlyViewed.getProductInformation(parent, displayProducts, productHandle);
    } else if ($('.js-recently-viewed .rv-main').length) {
      const parent = '.js-recently-viewed';
      const recentlyViewedProductsLoaded = $(parent).data('recently-viewed-items-loaded');

      if (recentlyViewedProductsLoaded) {
        return false;
      }

      window.recentlyViewed.getProductInformation(parent, displayProducts, productHandle);
    }

    if ($('.sidebar .js-sidebar-recently-viewed').length) {
      const parent = '.sidebar .js-sidebar-recently-viewed';
      const recentlyViewedProductsLoaded = $(parent).data('recently-viewed-items-loaded');
      if (recentlyViewedProductsLoaded) {
        return false;
      }

      if (productHandle) {
        window.recentlyViewed.getProductInformation(parent, displayProducts, productHandle);
      } else {
        window.recentlyViewed.getProductInformation(parent, displayProducts);
      }
    }
  },
  getCookieProducts(rvCookie, productHandle) {
    if (!rvCookie && productHandle) {
      window.Cookies.set(
        'recentlyViewed',
        productHandle,
        {
          expires: 30,
          path: '/',
          sameSite: 'None',
          secure: true,
        },
      );
      rvCookie = window.Cookies.get('recentlyViewed');
    } else {
      rvCookie = window.Cookies.get('recentlyViewed');
    }

    return rvCookie;
  },
  setCookieProducts(rvProductArray) {
    window.Cookies.set(
      'recentlyViewed',
      escape(rvProductArray.join(',')),
      {
        expires: 30,
        path: '/',
        sameSite: 'None',
        secure: true,
      },
    );
  },
  getProductInformation(parent, displayProducts, productHandle) {
    // Add data-attribute 'recently-viewed-items-loaded="true" to parent container
    $(parent).attr('data-recently-viewed-items-loaded', 'true');

    if (productHandle) {
      displayProducts.splice($.inArray(productHandle, displayProducts), 1);
    }

    const productLimit = $(parent).data('visible-products');

    if (productLimit && displayProducts) {
      displayProducts = displayProducts.slice(0, productLimit);
    }

    $.each(displayProducts, (index, value) => {
      if (value) {
        $(parent).removeClass('hidden');

        $(parent).parents('.sidebar-block').show();

        $.ajax({
          type: 'GET',
          url: `${window.PXUTheme.routes.all_products_collection_url}/products/${value}?view=rv`,
          success(data) {
            const rvProduct = $(data).find('.js-recently-viewed-product');

            $(parent).find(`.rv-box-${index}`).append(rvProduct);

            // Call enable gallery function for product galleries
            $(`.rv-box-${index} [data-product-gallery]`).each((_, gallery) => {
              const $productGallery = $(gallery);
              window.productPage.enableGallery($productGallery);
            });

            // Convert currencies
            if (window.PXUTheme.currency.show_multiple_currencies) {
              window.currencyConverter.convertCurrencies();
            }

            // Run option selectors
            window.productPage.runOptionSelector($(`.rv-box-${index}`));

            // Initialize shopify payment buttons
            if (Shopify.PaymentButton) {
              Shopify.PaymentButton.init();
            }

            // Hide <noscript> elements
            window.hideNoScript();

            // Initialize swatch toggler
            $('.swatch_options label').on('click', function() {
              window.quickShop.toggleSwatchImages($(this));
            });

            // Initialize the show secondary media on hover feature
            if (window.PXUTheme.theme_settings.collection_secondary_image) {
              window.imageFunctions.showSecondaryImage();
            }

            const $video = rvProduct.find('[data-html5-video] video, [data-youtube-video]');
            if ($video.length > 0) {
              window.videoFeature.setupPlayerForRecentlyViewedProducts(rvProduct.find('[data-html5-video] video, [data-youtube-video]'));
            }
          },
          error(x, t, m) {
            console.log(x);
            console.log(t);
            console.log(m);
          },
          dataType: 'html',
        });
      }

      if ($(parent).find('.rv-main').hasClass('js-rv-grid')) {
        if (displayProducts.length <= productLimit) {
          $('.js-rv-grid .thumbnail').eq(displayProducts.length).nextAll().addBack()
            .remove();
        } else {
          $('.js-rv-grid .thumbnail').eq(productLimit).nextAll().addBack()
            .remove();
        }
      }
    });
  }
};

/* ===============================================
  #Load more / infinite load
================================================== */

var enableLoadMoreProducts = function() {
  $('body').on('click', '.js-load-more a', function(e) {
    enableInfiniteScroll('[data-product-list]');
    e.stopPropagation();
    return false;
  });
}

var enableLoadMoreButton = function(parentClass) {

  var $grid = parentClass + '[data-load-more--grid]';
  var $gridItems = parentClass + ' [data-load-more--grid-item]';


  $('body').on('click', '[data-load-more]', function (e) {

    e.preventDefault();

    var $button = $(this);
    var url = $button.attr('href');

    loadNextPage(url, $button);
  });

  function loadNextPage(url, $button) {

    $.ajax({
      type: 'GET',
      dataType: 'html',
      url: url,
      beforeSend: function () {
        $button.addClass('is-loading');
        $('.loading-icon').addClass('loading-in-progress').css({
          'height': '40px',
          'width': '40px',
          'opacity': '1'
        });
      },
      success: function success(data) {
        $button.removeClass('is-loading');
        $('.loading-icon').removeClass('loading-in-progress').css({
          'height': '0',
          'width': '0',
          'opacity': '0'
        });

        const thumbnails = $(data).find($gridItems);

        var loadMoreButtonUrl = $(data).find('[data-load-more]').attr('href');

        $('[data-load-more]').attr('href', loadMoreButtonUrl);
        $($grid).first().append(thumbnails).append($('.js-load-more'));

        // Convert currencies
        if (window.PXUTheme.currency.show_multiple_currencies) {
          window.currencyConverter.convertCurrencies();
        }

        // Initialize the product page and run option selectors
        window.productPage.init();
        window.productPage.runOptionSelector(thumbnails);

        // Initialize shopify payment buttons
        if (Shopify.PaymentButton) {
          Shopify.PaymentButton.init();
        }

        // Initialize the quick shop
        if (window.PXUTheme.theme_settings.quick_shop_enabled) {
          window.quickShop.init();
        }
        document.dispatchEvent(new CustomEvent("swym:collections-reloaded"));
        document.dispatchEvent(new CustomEvent("collections-loaded"));
        // Hide <noscript> elements
        window.hideNoScript();

        // Initialize video players
        window.videoFeature.init();

        // Initialize the show secondary media on hover feature
        if (window.PXUTheme.theme_settings.collection_secondary_image) {
          window.imageFunctions.showSecondaryImage();
        }

        // When there are no additional pages, hide load more button
        if (typeof loadMoreButtonUrl == 'undefined') {
          $('[data-load-more]').addClass('is-hidden');
        }
      },
      error: function (x, t, m) {
        console.log(x);
        console.log(t);
        console.log(m);
        location.replace(location.protocol + '//' + location.host + filterURL);
      }
    });
  }
}

var enableInfiniteScroll = function(parentClass) {
  if ($(parentClass).length) {
    var infiniteScroll = new Waypoint.Infinite({
      element: $(parentClass)[0],
      items: parentClass,
      more: '[data-load-more]',
      loadingClass: 'loading-in-progress',
      onBeforePageLoad: function() {
        $('.js-load-more').hide();
      },
      onAfterPageLoad: function(data) {
        const $gridItems = $(`${parentClass} [data-load-more--grid-item]`);
        const thumbnails = $(data).find($gridItems);

        $(`${parentClass} > ${parentClass} .thumbnail`).unwrap(parentClass);

        // Convert currencies
        if (window.PXUTheme.currency.show_multiple_currencies) {
          window.currencyConverter.convertCurrencies();
        }

        // Initialize the product page and run option selectors
        window.productPage.init();
        window.productPage.runOptionSelector(thumbnails);

        // Initialize shopify payment buttons
        if (Shopify.PaymentButton) {
          Shopify.PaymentButton.init();
        }

        // Initialize the quick shop
        if (window.PXUTheme.theme_settings.quick_shop_enabled) {
          window.quickShop.init();
        }

        // Hide <noscript> elements
        window.hideNoScript();

        // Initialize video players
        window.videoFeature.init();

        // Initialize the show secondary media on hover feature
        if (window.PXUTheme.theme_settings.collection_secondary_image) {
          window.imageFunctions.showSecondaryImage();
        }
        document.dispatchEvent(new CustomEvent("swym:collections-reloaded"));
        document.dispatchEvent(new CustomEvent("collections-loaded"));
        // Refresh waypoints
        Waypoint.refreshAll();
      }
    })
  }
}

window.hideNoScript = function(){
  // Used to ensure noscript elements are hidden when JS is present.
  $('.image__container .noscript').addClass('hidden');
}

/*============================================================================
  #Filter Products with AJAX
==============================================================================*/

Shopify.queryParams = {};
if (location.search.length) {
 for (var aKeyValue, i = 0, aCouples = location.search.substr(1).split('&'); i < aCouples.length; i++) {
    aKeyValue = aCouples[i].split('=');
    if (aKeyValue.length > 1) {
     Shopify.queryParams[decodeURIComponent(aKeyValue[0])] = decodeURIComponent(aKeyValue[1]);
    }
  }
}

var quickFilter = {
  init() {
    // inside quickFilter.init(), very first line:
    //if(window.collectionSidebarFilter?.syncAllDuplicateStates) window.collectionSidebarFilter.syncAllDuplicateStates();

    var selectedOptions = [],
        query = '',
        currentTags = '';

    //Handle dropdowns if they exist
    if ($('#sort-by').length){
      query = $('#sort-by').val();
    } else {
      query = new URLSearchParams(window.location.search).get('sort_by');
    }

    if ($('#tag_filter').length){
      var $tagFilterValue = $('#tag_filter').val();

      if ($('#tag_filter').data('default-collection') != $tagFilterValue){
        urlTag = $tagFilterValue.substr($tagFilterValue.lastIndexOf('/') + 1);
        var tagFilterUrl = $tagFilterValue.substr($tagFilterValue)

        // apply the selected attribute to the proper option value in tag filter dropdown
        $('#tag_filter option').removeAttr('selected');
        $('#tag_filter option[value="' + tagFilterUrl + '"]').attr('selected', 'selected')

        if (urlTag != 'all'){
          if ($.inArray( urlTag, selectedOptions ) > -1){
            //Do nothing
          } else {
            selectedOptions.unshift(urlTag);
          }
        }
      }
    }

    //Add all checkbox values to array
    $('[data-option-filter] input:checked').each(function (){
      selectedOptions.push($(this).val());
    });
    selectedOptions = $.makeArray(selectedOptions);

    //Loop through tags to create string to update page url
    $.each(selectedOptions, function(i, value){

      if (i != selectedOptions.length - 1) {
        currentTags += selectedOptions[i] + '+';
      } else {
        currentTags += selectedOptions[i];
      }

    });

    Shopify.queryParams.sort_by = query;
    query = '?' + $.param(Shopify.queryParams).replaceAll('%2B', '+');
    
    quickFilter.processUrl(currentTags, query);
  },
  updateView(filterURL) {

    $.ajax({
      type: 'GET',
      url: filterURL,
      beforeSend: function() {
        $("body").addClass("loading-bar-active");
        //$('.product-list--collection').addClass('fadeOut animated loading-in-progress filter-loading');
        Waypoint.destroyAll();
      },
      success: function(data) {
        const $gridItems = $('.product-list--collection:not([data-predictive-search] .product-list--collection) [data-load-more--grid-item]');
        const thumbnails = $(data).find($gridItems);
        const searchTitle = $(".search__header-title");
        if(searchTitle) {
          $(".search__header-title").html($(data).find('.search__header-title').html())
        }
        $('.collection-section .product-list--collection').removeClass('loading-in-progress');
        $(".collection-section .product-list--collection").removeClass('filter-loading');
        $("body").removeClass("loading-bar-active")
        var filteredBreadcrumb = $(data).find('.breadcrumb_text').html();
        $('.collection-section .breadcrumb_text').html(filteredBreadcrumb);

        var filteredPagination = $(data).find('.paginate').html();
        $('.collection-section .paginate').html(filteredPagination);

        var filteredSidebar = $(data).find('.sidebar').html();
        $('.collection-section .sidebar').html(filteredSidebar);

        var filteredPageLinks = $(data).find('.paginate').html();
        $('.paginate').empty();
        $('.paginate').html(filteredPageLinks);

        var filteredData = $(data).find('.product-list--collection');
        $('.collection-section .product-list--collection').remove();
        filteredData.insertBefore( $('.loading-icon') );

        window.history && window.history.pushState && window.history.pushState("", "", filterURL);
        window.sidebarAccordions.init();
        if ($('.sidebar__collection-filter').length){
          window.collectionSidebarFilter.init();
          window.window.collectionSidebarDrawer.init();
        }

        // Reload recently viewed products
        window.recentlyViewed.init();

        // Convert currencies
        if (window.PXUTheme.currency.show_multiple_currencies) {
          window.currencyConverter.convertCurrencies();
        }

        // Initialize the product page and run option selectors
        window.productPage.init();
        window.productPage.runOptionSelector(thumbnails);

        // Initialize shopify payment buttons
        if (Shopify.PaymentButton) {
          Shopify.PaymentButton.init();
        }

        // Prevent event bubbling
        $('body').off('click', '.swatch-element');

        // Reload product swatches
        window.productPage.productSwatches();

        // Initialize swatch toggler
        $('.swatch_options label').on('click', function() {
          window.quickShop.toggleSwatchImages($(this));
        });
        document.dispatchEvent(new CustomEvent("swym:collections-reloaded"));
        document.dispatchEvent(new CustomEvent("collections-loaded"));
        // Load more / infinite load

        if (window.PXUTheme.theme_settings.pagination_type === 'load_more') {
          window.enableLoadMoreProducts();
        }

        if (window.PXUTheme.theme_settings.pagination_type === 'load_more_button') {
          window.enableLoadMoreButton('.collection-section [data-product-list]');
        }
        
        if (window.PXUTheme.theme_settings.pagination_type === 'infinite_scroll') {
          window.enableInfiniteScroll('.collection-section [data-product-list]');
        }
      },
      error: function(x, t, m) {
        console.log(x);
        console.log(t);
        console.log(m);
        location.replace(location.protocol + '//' + location.host + filterURL);

      },
      dataType: "html"
    });
  },
  processUrl(tags, query) {
    // const currentPath = window.location.pathname.split('/');

    // const newQuery = query.replace(/\page=(\w+)&/, '');

    // const endIndex = currentPath.indexOf('collections') + 1;
    // const newPath = currentPath.slice(0, endIndex + 1).join('/') + '/';

    // const urlString = newPath + tags + newQuery;
    // console.log("URL:" + urlString);
    const currentPath = window.location.pathname.split('/');
    const href = window.location.href;
    const isSearchPage = currentPath.includes('search');
    const checkboxes = document.querySelectorAll('.faceted-filter-group-display__list-item-input:checked');
    const params = new URLSearchParams();
    if (isSearchPage) {
      const match = href.match(/[?&]q=([^&]+)/);
      if (match && match[1]) {
        params.set('q', decodeURIComponent(match[1]));
      }
    }
    checkboxes.forEach(input => {
      const name = input.getAttribute('name');  // e.g. "filter.p.product_type"
      const value = input.value;                // e.g. "Decal / Sticker"
      if (name && value) {
        params.append(name, value); // URLSearchParams handles encoding
      }
    });
  
    const sortSelect = document.querySelector('[data-sort-by]');
    if (sortSelect && sortSelect.value) {
      params.set('sort_by', sortSelect.value);
    }
    
    const finalURL = `${window.location.pathname}?${params.toString()}`;
    //console.log("FINAL URL:" + finalURL);
    quickFilter.updateView(finalURL);

  }
}


/*============================================================================
  #Predictive search
==============================================================================*/

window.predictiveSearch = {
  init() {
    this.events = new EventHandler();
    this.forms = document.querySelectorAll('form[data-autocomplete-true]:not(.search-form--header)');

    this.forms.forEach(form => {
      const input = form.querySelector('[data-search-input]');
      const results = form.querySelector('[data-predictive-search-results]');
      const resultsContainer = form.querySelector('[data-predictive-search]');
      const animation = window.animations.transition({ el: resultsContainer });

      this.events.register(form, 'submit', e => this._onSubmit(e, input));
      this.events.register(window, 'resize', debounce(() => this._onResize(resultsContainer), 250));
      this.events.register(window, 'keyup', e => this._onKeyUp(e, form, input, animation));
      this.events.register(input, 'focus', () => this._onFocus(form, input, results, resultsContainer, animation));
      this.events.register(resultsContainer, 'focusout', (e) => this._onFocusOut(e, form, animation));
      this.events.register(input, 'input', debounce(() => this._onChange(form, input, results, resultsContainer, animation), 250));

      this.events.register(document.body, 'click', e => {
        if (form.classList.contains('search-form--active') && !form.contains(e.target)) {
          this._close(form, animation);
        }
      });
    });
  },
  _onSubmit(e, input) {
    // Prevent empty form submissions
    if (this._getQuery(input).length === 0) e.preventDefault();
  },
  _onResize(resultsContainer) {
    this._resizeSearchResults(resultsContainer);
  },
  _onKeyUp(e, form, input, animation) {
    if (e.code === 'Escape') {
      input.value = '';

      this._close(form, animation);
    }
  },
  _onFocus(form, input, results, resultsContainer, animation) {
    const term = this._getQuery(input);

    if (term.length === 0) return;

    this._fetchResults(term, form, results, resultsContainer);
    this._open(form, resultsContainer, animation);
  },
  _onFocusOut(e, form, animation) {
    if (e.target.matches('[data-search-button]')) {
      this._close(form, animation);
    }
  },
  _onChange(form, input, results, resultsContainer, animation) {
    const term = this._getQuery(input);

    if (term.length === 0) {
      this._close(form, animation);
      return;
    }

    this._fetchResults(term, form, results, resultsContainer);
    this._open(form, resultsContainer, animation);
  },
  _getQuery(input) {
    return input.value.trim();
  },
  _open(form, resultsContainer, animation) {
    form.classList.add('search-form--active');

    if (!window.PXUTheme.media_queries.medium.matches) {
      document.body.classList.add('scroll-locked');
    }

    animation.animateTo('open');
    this._resizeSearchResults(resultsContainer);
  },
  _close(form, animation) {
    form.classList.remove('search-form--active');

    if (!window.PXUTheme.media_queries.medium.matches) {
      document.body.classList.remove('scroll-locked');
    }

    animation.animateTo('closed');
  },
  _fetchResults(term, form, results, resultsContainer) {
    const resourceType = form.classList.contains('search-form--blog') ? '&resources[type]=article' : '';

    resultsContainer.setAttribute('data-loading', 'true');

    fetch(`${window.PXUTheme.routes.predictive_search_url}?q=${encodeURIComponent(term)}${resourceType}&section_id=predictive-search`)
      .then(response => {
        if (!response.ok) {
          const error = new Error(response.status);
          throw error;
        }

        return response.text();
      })
      .then(text => {
        const resultsMarkup = new DOMParser().parseFromString(text, 'text/html').querySelector('#shopify-section-predictive-search').innerHTML;
        this._renderResults(resultsMarkup, results, resultsContainer);
      })
      .catch(error => {
        throw error;
      });
  },
  _renderResults(resultsMarkup, results, resultsContainer) {
    resultsContainer.setAttribute('data-loading', 'false');
    results.innerHTML = resultsMarkup;
  },
  _resizeSearchResults(resultsContainer) {
    if(!resultsContainer) return;
    const offset = 30;
    const position = resultsContainer.parentNode.getBoundingClientRect();
    const maxHeight = window.innerHeight - position.bottom - offset;

    resultsContainer.style.setProperty('--search-results-max-height', `${maxHeight}px`);
  }
}



/*============================================================================
  #searchAutoComplete – predictive suggestions · top filters · live previews
============================================================================*/
window.searchAutoComplete = {
  /* ─── tunables ─────────────────────────────────────────────────── */
  TYPE_DELAY  : 500,  // debounce when typing
  HOVER_DELAY : 500,  // debounce on hover / tap
  MAX_GROUPS  : 3,
  MAX_VALUES  : 6,

  /* ─── in-memory caches ─────────────────────────────────────────── */
  predictiveCache : new Map(),   // term → {qHtml,pHtml}
  filterCache     : new Map(),   // term → JSON
  productCache    : new Map(),   // url  → HTML (view=searchTypes)

  /* ─── boot ─────────────────────────────────────────────────────── */
  init() {
    this.events = new EventHandler();
    document.querySelectorAll('form[data-autocomplete-true].search-form--header').forEach(f => this._wireForm(f));
  },

  /* ─── per-form wiring ─────────────────────────────────────────── */
  _wireForm(form) {
    const inputEl   = form.querySelector('[data-search-input]');
    const boxEl     = form.querySelector('[data-predictive-search]');
    const resultsEl = form.querySelector('[data-predictive-search-results]');
    const closeBtn = form.querySelector('.icon-close-custom');
    if (!boxEl || !resultsEl) return;

    const slotSug  = resultsEl.querySelector('[data-query-suggestions]');
    const slotFilt = resultsEl.querySelector('[data-filter-groups]');
    const slotProd = resultsEl.querySelector('[data-product-suggestions]');
    const anim     = window.animations.transition({ el: boxEl });

    const openUI  = () => { form.classList.add('search-form--active'); anim.animateTo('open'); };
    const closeUI = () => { form.classList.remove('search-form--active'); anim.animateTo('closed'); };

    /* ---- repaint helper ----------------------------------------- */
    const paint = (pred, filt, viewUrl) => {
      slotSug.innerHTML = pred.qHtml;
      this._setProducts(slotProd, pred.pHtml, viewUrl, filt.products || []);
      this._renderFilters(filt, slotFilt);
      boxEl.setAttribute('data-loading','false');
    };

    
    const outsideHandler = (e) => {
      // do nothing if click stayed inside the form (input, results, etc.)
      if (form.contains(e.target)) return;
      closeUI();
    };
    if(closeBtn){
      this.events.register(closeBtn , 'click', closeUI);
    }
    
    this.events.register(document, 'mousedown', outsideHandler);
    this.events.register(document, 'touchstart', outsideHandler);
    /* ---- typing handler ----------------------------------------- */
    const onType = async () => {
      const term = inputEl.value.trim();
      if (!term) { closeUI(); return; }
      openUI();  boxEl.setAttribute('data-loading','true');

      const [pred,filt] = await Promise.all([
        this._fetchPredictive(term, form),
        this._fetchFilters(term)
      ]);

      paint(pred, filt, `${window.PXUTheme.routes.search_url}?q=${encodeURIComponent(term)}`);
    };

    /* ---- basic UX events ---------------------------------------- */
    this.events.register(inputEl,'input', this._debounce(onType, this.TYPE_DELAY));
    this.events.register(form,'submit',e=>{ if(!inputEl.value.trim()) e.preventDefault(); });
    this.events.register(window,'keyup',e=>{ if(e.code==='Escape'){ inputEl.value=''; closeUI(); } });

    /* ---- filter chip hover / tap → products --------------------- */
    let cancelFilterHover = null;

    if (matchMedia('(hover:hover)').matches) {
      cancelFilterHover = this._hoverIntent(slotFilt,'[data-url]',this.HOVER_DELAY,(li) => {
          const baseUrl  = this._cleanView(li.dataset.url);
          const typesUrl = this._toSearchTypes(li.dataset.url);
          this._fetchProductSlot(typesUrl).then(html => this._setProducts(slotProd, html, baseUrl));
        }
      );
    } else {
      this.events.register(slotFilt,'click',(ev)=>{
        const li = ev.target.closest('[data-url]'); if(!li) return;
        const baseUrl  = this._cleanView(li.dataset.url);
        const typesUrl = this._toSearchTypes(li.dataset.url);
        this._fetchProductSlot(typesUrl).then(html => this._setProducts(slotProd, html, baseUrl));
      });
    }

    /* ---- suggestion hover → filters + products ------------------ */
    let cancelSuggestHover = this._hoverIntent(slotSug,'a',this.HOVER_DELAY,(a) => {
        const term     = a.textContent.trim();
        const baseUrl  = a.href;
        const typesUrl = `${window.PXUTheme.routes.search_url}?q=${encodeURIComponent(term)}&view=searchTypes`;

        this._fetchProductSlot(typesUrl).then(html => this._setProducts(slotProd, html, baseUrl));

        this._fetchFilters(term).then(j => this._renderFilters(j, slotFilt));
      }
    );
  },
  // ── Hover Intent helper (delegated)
  _hoverIntent(container, itemSelector, delay, onTrigger) {
    let timer = null;
    let current = null;

    const over = (ev) => {
      const item = ev.target.closest(itemSelector);
      if (!item || !container.contains(item)) return;
      if (current === item) return;
      current = item;
      clearTimeout(timer);
      timer = setTimeout(() => {
        // still over the same item?
        if (current === item) onTrigger(item);
      }, delay);
    };

    const out = (ev) => {
      // if leaving the whole container, cancel; if moving between siblings, restart on next over
      const toEl = ev.relatedTarget;
      if (toEl && container.contains(toEl)) return;
      clearTimeout(timer);
      timer = null;
      current = null;
    };

    // Mouse users
    this.events.register(container, 'mouseover', over);
    this.events.register(container, 'mouseleave', out);

    // Return a cancel function so other zones can cancel pending intent
    return () => { clearTimeout(timer); timer = null; current = null; };
  },
  /* ─── network helpers ─────────────────────────────────────────── */
  async _fetchPredictive(term, form) {
    if (this.predictiveCache.has(term)) return this.predictiveCache.get(term);

    const blog = form.classList.contains('search-form--blog') ? '&resources[type]=article' : '';
    const url  = `${window.PXUTheme.routes.predictive_search_url}?q=${encodeURIComponent(term)}${blog}&section_id=predictive-search`;
    const html = await fetch(url).then(r=>r.text());
    const doc  = new DOMParser().parseFromString(html,'text/html');
    const res  = {
      qHtml : doc.querySelector('.predictive-search__query-suggestions')?.innerHTML || '',
      pHtml : doc.querySelector('.predictive-search__product-suggestions')?.outerHTML || ''  // <- was innerHTML
    };

    this.predictiveCache.set(term, res);
    return res;
  },

  async _fetchFilters(term) {
    if (this.filterCache.has(term)) return this.filterCache.get(term);

    const url  = `${window.PXUTheme.routes.search_url}?q=${encodeURIComponent(term)}&view=searchFilters&sort_by=best-selling`;
    try {
      const txt   = await fetch(url).then(r=>r.text());
      const clean = txt.replace(/,\s*([\]}])/g,'$1');   // remove trailing commas
      const json  = JSON.parse(clean);
      this.filterCache.set(term, json);
      //console.log(json);
      return json;
    } catch { return { results: [], products: [] }; }
  },

  async _fetchProductSlot(url) {
    if (this.productCache.has(url)) return this.productCache.get(url);

    const html = await fetch(url).then(r=>r.text());
    const snippet = new DOMParser().parseFromString(html,'text/html').querySelector('.predictive-search__product-suggestions')?.outerHTML || '';
    this.productCache.set(url, snippet);
    return snippet;
  },
  _renderExtraProducts(products) {
    return products.map(p => `
      <li class="predictive-search__list-item" role="listitem">
        <a class="predictive-search__list-item-anchor" href="${p.url}">
          <figure class="predictive-search__list-item-thumbnail">
            <div class="image-element__wrap" style="max-width:${p.image_width || 2000}px;">
              <img class="transition--blur-up lazyautosizes lazyloaded"  alt="${p.title}"  src="${p.image}"  data-src="${p.image}"  data-sizes="auto" />
            </div>
            <noscript>
              <img class="noscript" src="${p.image}" alt="${p.title}" />
            </noscript>
          </figure>
          <div class="predictive-search__list-item-content">
            <p class="predictive-search__list-item-title">${p.title}</p>
            <p class="predictive-search__list-item-price">
              <span class="current_price">
                <span class="money">${p.price}</span>
              </span>
              <span class="was_price">
                ${p.compare_at_price && p.compare_at_price !== p.price
                  ? `<span class="money">${p.compare_at_price}</span>` : ''}
              </span>
            </p>
          </div>
        </a>
      </li>
    `).join('');
  },
  /* ─── DOM helpers ─────────────────────────────────────────────── */
  _setProducts(target, predictiveHtml, viewUrl, extraProducts = []) {
    target.innerHTML = predictiveHtml;

    let container = target.querySelector('.predictive-search__product-suggestions');
    let list = container?.querySelector('.predictive-search__results-list');

    // If predictive returned no product block, create one so we can render extras
    if (!list) {
      target.innerHTML = `
        <div class="predictive-search__product-suggestions">
          <h2 class="predictive-search__heading"><span>Suggestions</span></h2>
          <ul class="predictive-search__results-list" role="list"></ul>
        </div>`;
      container = target.querySelector('.predictive-search__product-suggestions');
      list = container.querySelector('.predictive-search__results-list');
    }

    // Hard cap: 16 total items. If predictive overshoots, trim.
    const CAP = 16;
    while (list.children.length > CAP) list.removeChild(list.lastElementChild);

    // Append extras up to the cap
    if (extraProducts && extraProducts.length) {
      const existingUrls = new Set([...list.querySelectorAll('.predictive-search__list-item a')].map(a => a.getAttribute('href')));
      const uniqueExtras = extraProducts.filter(p => !existingUrls.has(p.url));
      const canAppend = Math.max(0, CAP - list.children.length);
      if (canAppend > 0 && uniqueExtras.length) {
        const extrasHTML = this._renderExtraProducts(uniqueExtras.slice(0, canAppend));
        list.insertAdjacentHTML('beforeend', extrasHTML);
      }
    }

    // Ensure the "View all" button exists/updates
    const heading = container.querySelector('.predictive-search__heading');
    if (heading) {
      heading.querySelector('.ps-view-all')?.remove();
      const btn = document.createElement('a');
      btn.className = 'ps-view-all global-button';
      btn.href = viewUrl;
      btn.textContent = 'View all';
      heading.appendChild(btn);
    }
  },


  _renderFilters(json, host) {
    host.innerHTML = '';
    (json.results||[])
      .map(g=>{
        const unique=[...new Map(g.values.filter(v=>v.count)
          .map(v=>[v.label.toLowerCase(),v])).values()]
          .sort((a,b)=>b.count-a.count).slice(0,this.MAX_VALUES);
        return { label:g.label, values:unique, top:unique[0]?.count||0 };
      })
      .filter(g=>g.values.length)
      .sort((a,b)=>b.top-a.top)
      .slice(0,this.MAX_GROUPS)
      .forEach(g=>{
        const chips = g.values.map(v=>`
          <li data-url="${this._cleanView(v.url_to_add)}">${v.label}</li>
        `).join('');
        host.insertAdjacentHTML('beforeend',`
          <div class="ps-filter"><span>${g.label}</span><ul>${chips}</ul></div>
        `);
      });
  },

  /* ─── url helpers ─────────────────────────────────────────────── */
  _cleanView(url){ return url.replace(/([?&])view=[^&]+/,'').replace(/[?&]$/,''); },
  _toSearchTypes(url){ const base=this._cleanView(url); return base+(base.includes('?')?'&':'?')+'view=searchTypes'; },

  /* ─── debounce util ───────────────────────────────────────────── */
  _debounce(fn,ms){let t;return(...a)=>{clearTimeout(t);t=setTimeout(()=>fn.apply(this,a),ms);};}
};

/*============================================================================
  #Mobile search
==============================================================================*/

window.mobileSearch = {
  init() {
    this.events = new EventHandler();
    this.el = document.querySelector('[data-mobile-search]');
    this.closeEl = this.el.querySelector('[data-mobile-search-close]');
    this.animation = window.animations.transition({ el: this.el, state: 'closed' });

    this.events.register(this.closeEl, 'click', () => this.close());

    this.closed = true;
  },
  open() {
    if (this.closed) {
      this.animation.animateTo('open');
      window.siteOverlay.open();
      this.closed = false;
    }
  },
  close() {
    if (!this.closed) {
      this.animation.animateTo('closed');
      window.siteOverlay.close();
      this.closed = true;
    }
  },
  isClosed() {
    return this.closed;
  }
}

/*============================================================================
  #Site overlay
==============================================================================*/

window.siteOverlay = {
  init() {
    this.events = new EventHandler();
    this.el = document.querySelector('[data-site-overlay]');
    this.animation = window.animations.transition({ el: this.el, state: 'closed' });

    this.events.register(this.el, 'click', () => this.close());

    this.closed = true;
  },
  open() {
    if (this.closed) {
      document.body.classList.add('scroll-locked');
      this.animation.animateTo('open');
      this.closed = false;
    }
  },
  close() {
    if (!this.closed && window.PXUTheme.media_queries.medium.matches) {
      document.body.classList.remove('scroll-locked');
      this.animation.animateTo('closed');
      this.closed = true;

      if (!window.mobileSearch.isClosed()) {
        window.mobileSearch.close();
      }
    }
  },
  isClosed() {
    return this.closed;
  }
}

/*============================================================================
  #Sidebar filter on collection pages
==============================================================================*/
window.collectionSidebarFilter = {
  init: function () {
    $('.filter-active-tag input:checked').parents('.filter-active-tag').siblings('.filter-all-tags').hide();

    const openActiveFilters = () => {
      const sidebar = document.querySelector('[data-sidebar]');
      if (!sidebar) return;

      const sidebarBlocks = sidebar.querySelectorAll('[data-sidebar-block]');
      if (!window.PXUTheme.media_queries.medium.matches) {
        sidebarBlocks.forEach(block => {
          if (block.querySelector('[data-active-legacy-filter]')) {
            block.open = true;
          }
        });
      }
    };

    openActiveFilters();
    //window.collectionSidebarFilter.dedupeFacetedFilters();
    // Hide filters if types or vendors is in URL (can't be combined)
    const pathSegments = window.location.pathname.split('/').filter(Boolean);
    if (pathSegments[1] === 'types' || pathSegments[1] === 'vendors') {
      $('.sidebar__collection-filter').remove();
    }

    $('.sidebar-block:empty').prev().css('border-bottom', 'none');

    // Intercept filter input changes and trigger quickFilter
    $('body').off('change.sidebarFilter').on('change.sidebarFilter', '[data-option-filter] input', function () {
      if (typeof window.quickFilter?.init === 'function') {
        window.quickFilter.init();
      }
    });

    // Intercept sidebar form submit (Enter key or fallback)
    document.querySelectorAll('[data-faceted-filter-form]').forEach(form => {
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        e.stopPropagation();
        if (typeof window.quickFilter?.init === 'function') {
          window.quickFilter.init();
        }
        return false;
      });
    });
    $('body').off('click.removeFilter').on('click.removeFilter', '.faceted-active-filters__remove-filter, .faceted-active-filters__clear', function (e) {
      e.preventDefault();
      const href = $(this).attr('href');
      if (href && typeof window.quickFilter?.updateView === 'function') {
        window.quickFilter.updateView(href);
      }
    });
    // Will reload recently viewed if present
    window.recentlyViewed.init();
  },
  syncAllDuplicateStates:function(){
    if(!this._dedupeIndex) return;
    Object.values(this._dedupeIndex).forEach(group=>{
      const anyChecked=group.some(i=>i.checked);
      group.forEach(i=>i.checked=anyChecked);
    });
  },
  dedupeFacetedFilters:function(){
    const normalize=s=>(s||'').toString().toLowerCase().replace(/\s+/g,'').replace(/[\u200B-\u200D\uFEFF]/g,'');
    const INPUT_SELECTOR='[data-option-filter] input[type="checkbox"],.faceted-filter-group-display__list input[type="checkbox"]';
    const buildIndex=()=>{
      const inputs=[...document.querySelectorAll(INPUT_SELECTOR)];
      const idx={};
      inputs.forEach(input=>{
        const key=input.name+'::'+normalize(input.value);
        (idx[key]??=[]).push(input);
      });
      Object.values(idx).forEach(arr=>{
        if(arr.length>1) arr.forEach((input,i)=>{ if(i>0){const li=input.closest('li'); if(li) li.style.display='none';}});
      });
      this._dedupeIndex=idx;
    };
    buildIndex();
    const sidebarEl=document.querySelector('[data-sidebar]');
    if(sidebarEl&&!this._dedupeMO){ this._dedupeMO=new MutationObserver(()=>buildIndex()); this._dedupeMO.observe(sidebarEl,{subtree:true,childList:true});}
  },




  clearAllFilters: function () {
    $('[data-option-filter] input').prop('checked', false);
    $('[data-option-filter] input').trigger('change');
    window.recentlyViewed.init();
  },

  clearSelectedFilter: function (optionFilter) {
    if ($('#tag_filter').length) {
      const tagValue = optionFilter.find('[data-option-filter] input').val();
      const selectedTag = $('#tag_filter option:selected').val()?.split('/').pop();
      if (tagValue === selectedTag) {
        $('#tag_filter').val($('#tag_filter option:first').val());
      }
    }

    optionFilter.find('[data-option-filter] input').prop('checked', false).trigger('change');
    window.recentlyViewed.init();
  }
}
window.collectionSidebarDrawer = {
    init: function () {
      // Unbind previous handlers
      $('body').off('.collectionSidebarDrawer');
      $(document).off('.collectionSidebarDrawer');

      // Initialize each mobile drawer container
      $('.mobile-drawer-filters').each(function () {
        var $container = $(this);
        var $sidebar = $container.find('[data-sidebar]');
        var $toggle = $container.find('[data-sidebar-toggle]');
        if (!$sidebar.length || !$toggle.length) return;

        // Ensure backdrop exists
        var $backdrop = $container.find('.sidebar-backdrop');
        if (!$backdrop.length) {
          $backdrop = $('<div class="sidebar-backdrop" hidden></div>');
          $container.append($backdrop);
        }

        // Open/close helpers
        function open() {
          $sidebar.addClass('is-open');
          $backdrop.addClass('is-active').prop('hidden', false);
          $('html, body').addClass('no-scroll');
          $toggle.attr('aria-expanded', 'true');
        }
        function close() {
          $sidebar.removeClass('is-open');
          $backdrop.removeClass('is-active');
          $('html, body').removeClass('no-scroll');
          $toggle.attr('aria-expanded', 'false');
          setTimeout(function () {
            if (!$backdrop.hasClass('is-active')) {
              $backdrop.prop('hidden', true);
            }
          }, 200);
        }

        // Toggle click
        $container
          .off('click.collectionSidebarDrawer', '[data-sidebar-toggle]')
          .on('click.collectionSidebarDrawer', '[data-sidebar-toggle]', function (e) {
            e.preventDefault();
            $sidebar.hasClass('is-open') ? close() : open();
          });

        // Backdrop click
        $backdrop
          .off('click.collectionSidebarDrawer')
          .on('click.collectionSidebarDrawer', close);
      });

      // Esc key closes any open drawer
      $(document).on('keyup.collectionSidebarDrawer', function (e) {
        if (e.key === 'Escape') {
          $('.mobile-drawer-filters [data-sidebar].is-open').each(function () {
            var $sidebar = $(this);
            var $container = $sidebar.closest('.mobile-drawer-filters');
            $container.find('[data-sidebar-toggle]').trigger('click.collectionSidebarDrawer');
          });
        }
      });
    },

    // Programmatic controls (pass container selector or element)
    open: function (container) {
      var $c = $(container || '.mobile-drawer-filters').first();
      $c.find('[data-sidebar-toggle]').trigger('click.collectionSidebarDrawer');
    },
    close: function (container) {
      var $c = $(container || '.mobile-drawer-filters').first();
      $c.find('.sidebar-backdrop').trigger('click.collectionSidebarDrawer');
    },

    // Alias for re-init
    reinit: function () {
      this.init();
    }
  }

window.sidebarAccordions = {
  init: function() {
    const sidebar = document.querySelector('[data-sidebar]');

    if (!sidebar) return;

    const sidebarBlocks = sidebar.querySelectorAll('[data-sidebar-block]');
    const facetedFilterForm = sidebar.querySelector('[data-faceted-filter-form]');
    const openAllDefault = sidebar.dataset.openAll === 'true';
    const allowToggleOnDesktop = sidebar.dataset.sidebarAllowToggle === 'true';

    const closeAll = () => sidebarBlocks.forEach(block => { block.open = false; });
    const openAll = () => sidebarBlocks.forEach(block => { block.open = true; });

    let wasMobileLastResize = false;

    const setState = () => {
      if (window.PXUTheme.media_queries.medium.matches) {
        if (!wasMobileLastResize) {
          closeAll();
        }
        wasMobileLastResize = true;
      } else {
        if (!allowToggleOnDesktop) {
          openAll();
        }
        wasMobileLastResize = false;
      }
      if(openAllDefault){
        openAll();
      }
    };

    setState();

    window.addEventListener('resize', setState);

    // Faceted filtering

    if (facetedFilterForm) {
      // Submit the faceted filtering form when selecting a checkbox
      facetedFilterForm.addEventListener('keypress', e => {
        if (e.target.classList.contains('faceted-filter-group-display__list-item-input')) {
          if (event.keyCode == 13) {
            if (e.target.checked) {
              e.target.checked = false;
            } else {
              e.target.checked = true;
            }
          }
        }
      });

      const sortByEl = document.querySelector('[data-sort-by]');

      facetedFilterForm.addEventListener('change', e => {
        const isSortSelect = e.target.matches('[data-sort-by]');
        if (isSortSelect) return;
      
        if (e.target.type === 'checkbox' || e.target.closest('[data-option-filter]')) {
          e.preventDefault();
          if (typeof window.quickFilter?.init === 'function') {
            window.quickFilter.init();
          }
        }
      });
    }

    const setOpenHeight = el => {
      el.style.setProperty('--open-height', `${el.scrollHeight}px`);
    };

    sidebarBlocks.forEach(block => {
      const summary = block.querySelector('summary');
      if (!summary) return;

      const transition = window.animations.transition({
        el: block,
        state: block.open ? 'open' : 'closed',
        stateAttribute: 'data-sidebar-block-state',
        stateChangeAttribute: 'data-sidebar-block-animation'
      });

      summary.addEventListener('click', e => {
        e.preventDefault();

        if (!window.PXUTheme.media_queries.medium.matches && !allowToggleOnDesktop) return;

        const { height: closedHeight } = summary.getBoundingClientRect();
        block.style.setProperty('--closed-height', `${closedHeight}px`);
        block.style.setProperty('--open-height', `${block.scrollHeight}px`);

        if (block.open) {
          block.open = false;
          transition.animateTo('closed');
        } else {
          block.open = true;
          transition.animateTo('open');
        }
      });
    })
  },
}

/*============================================================================
  #Misc
==============================================================================*/
if (window.PXUTheme.theme_settings.slideshow_arrow_size == 'bold'){
  window.arrowSize = {
    x0: 10,
    x1: 40, y1: 50,
    x2: 80, y2: 50,
    x3: 50
  }
  window.svgArrowSizeLeft = '<svg viewBox="0 0 100 100"><path d="M 10,50 L 40,100 L 80,100 L 50,50  L 80,0 L 40,0 Z" class="arrow"></path></svg>'
  window.svgArrowSizeRight = '<svg viewBox="0 0 100 100"><path d="M 10,50 L 40,100 L 80,100 L 50,50  L 80,0 L 40,0 Z" class="arrow" transform="translate(100, 100) rotate(180) "></path></svg>'
} else if (window.PXUTheme.theme_settings.slideshow_arrow_size == 'light'){
  window.arrowSize = {
    x0: 10,
    x1: 60, y1: 50,
    x2: 62, y2: 40,
    x3: 22
  }
  window.svgArrowSizeLeft = '<svg viewBox="0 0 100 100"><path d="M 10,50 L 60,100 L 62,90 L 22,50  L 62,10 L 60,0 Z" class="arrow"></path></svg>'
  window.svgArrowSizeRight = '<svg viewBox="0 0 100 100"><path d="M 10,50 L 60,100 L 62,90 L 22,50  L 62,10 L 60,0 Z" class="arrow" transform="translate(100, 100) rotate(180) "></path></svg>'
} else if (window.PXUTheme.theme_settings.slideshow_arrow_size == 'regular'){
  window.arrowSize = {
    x0: 10,
    x1: 60, y1: 50,
    x2: 70, y2: 40,
    x3: 30
  }
  window.svgArrowSizeLeft = '<svg viewBox="0 0 100 100"><path d="M 10,50 L 60,100 L 70,90 L 30,50  L 70,10 L 60,0 Z" class="arrow"></path></svg>'
  window.svgArrowSizeRight = '<svg viewBox="0 0 100 100"><path d="M 10,50 L 60,100 L 70,90 L 30,50  L 70,10 L 60,0 Z" class="arrow" transform="translate(100, 100) rotate(180) "></path></svg>'
}

window.isScreenSizeLarge = function isScreenSizeLarge() {
  if (window.matchMedia( "(min-width: 1024px)" ).matches) {
    return true;
  }
}

window.utils = {
  createAccordion: function(container, tab, content){
    var $container = $(container);
    var $tab = $(container).find(tab);
    var $content = $(container).find(content);
    var specificTab = container + ' ' + tab;

    //Check to see if need to rearrange product tabs to create accordion (backwards compatible)
    if (container.indexOf(".accordion-tabs") >= 0){
      var rearrangedTabs = $.map($tab, function(v, i) { return [v, $content[i]]; });
      $container.empty();

      $.each(rearrangedTabs, function (index, value) {
        $container.append(this);
      });

      $content.removeClass('active');
      $container.find('.active').next().slideToggle();

      tab = container + '> a';
    }

    $(container).children('a').each(function(i, tab) {
      var tab = $(this);
      var tabValue = tab.attr('href'); //get tab id
      tab.attr('data-tab-value', tabValue); //set tab id in data attribute
      tab.removeAttr("href"); //remove href (to prevent url hash update)
    });

    $(container).find(tab + '.active').next().slideToggle();
    $(specificTab).on('click', function(e) {
      e.preventDefault();
      $(this).toggleClass('active');
      $(this).next().slideToggle();
    });
  },
  mobileAccordion: function(container, tab) {
    $container = $(container);

    $tab = $(container).find(tab)
      .filter((_, el) => {
        const href = el.getAttribute('href');
        // `href === null` check is for disclosure links such as language/currency selectors.
        // Checking `href === '#'` won't work if there's a locale code (eg. `/fr#`).
        return !href || href === '/' || href.includes('#');
      });

    $(tab + '.active').next().slideToggle();

    $tab.on('click', function(e) {
      e.preventDefault();
      $(this).toggleClass('active');
      $(this).next().slideToggle();
    });
  },
  mobileParentActiveAccordion: function(container, tab) {
    $container = $(container);

    $tab = $(container).find(tab)
      .filter((_, el) => {
        const href = el.parentNode.getAttribute('href');
        return href !== '' && href !== '/' && !href.includes('#');
      });

    $(tab + '.active').parent().next().slideToggle();

    $tab.on('click', function(e) {
      e.preventDefault();
      $(this).toggleClass('active');
      $(this).parent().next().slideToggle();
    });
  },
  initializeTabs: function(){
    $('ul.tabs > li > a').attr('data-no-instant', true);
    $('body').on('click', 'ul.tabs > li > a', function(e) {
      e.preventDefault();
      var contentLocation = $(this).attr('href');
      if(contentLocation.charAt(0)=="#") {
        $('ul.tabs > li > a.active').removeClass('active');
        $(this).addClass('active');
        $(this).parents('ul.tabs').next().find(contentLocation).show().css({'display': 'block'}).addClass('active').siblings().hide().removeClass('active');
      }
    });
  },
  scrollToTop: function(element, height){
    // Check if height argument is present
    if(height != undefined) {
      $('html, body').animate({
        scrollTop: $(element).offset().top - height
      }, 1000);
    } else {
      $('html, body').animate({
        scrollTop: $(element).offset().top
      }, 1000);
    }
  },
  initializeSectionWrapper: function(){
    const firstSection = document.querySelector('.section-wrapper .shopify-section');

    if (!firstSection) return;

    window.navigationDesktopManager.initAll();

    if (firstSection.classList.contains('under-menu') && firstSection.querySelector('.full-width--true')) {
      if (!$('.header').hasClass('header-background--solid')) {
        $('.header').parent().addClass('feature_image');
        $('.header').addClass('is-absolute');
      }
      // Show the secondary logo
      if ($('.feature_image').hasClass('secondary_logo--true')){
        $('.secondary_logo--true').find('.secondary_logo').show();
        $('.secondary_logo--true').find('.primary_logo').hide();
      }
      window.headerFader.updateShouldFade(true);
    } else {
      $('.feature_image').removeClass('feature_image');
      $('.header.is-absolute').removeClass('is-absolute');
      // Hide the secondary logo
      if (!$('header.feature_image').hasClass('secondary_logo--true')){
        $('.secondary_logo--true').find('.secondary_logo').hide();
        $('.secondary_logo--true').find('.primary_logo').show();
      }
      window.headerFader.updateShouldFade(false);
    }
  },
  enableDisclosure: function() {

    var $disclosure = $('[data-disclosure]');
    var $toggle = $('[data-disclosure-toggle]');
    var $disclosureWrap = $('.disclosure__list-wrap');

    //Check if current opened menu is offscreen
    function checkOffScreen($openedToggle) {
      const el = $openedToggle.siblings('.disclosure__list-wrap')[0];
      const rect = el.getBoundingClientRect();

      if (rect.right > window.innerWidth) {
        $openedToggle.siblings('.disclosure__list-wrap').addClass('disclosure--left');
      }
    }

    function closeDisclosures(ignoreTarget, currentTarget) {
      if(ignoreTarget === true) {
        $toggle.not(currentTarget).removeClass('is-clicked');
        $toggle.not(currentTarget).attr('aria-expanded', 'false');
      } else {
        $toggle.removeClass('is-clicked');
        $toggle.attr('aria-expanded', 'false');
      }

      $disclosureWrap.removeClass('disclosure--left');
    }

    //Close menus on ESC
    $('body').on('keyup', function(e) {
      if(e.which == '27') {
        closeDisclosures();
      }
    });

    //Close menus on hoverout
    $disclosure.on('mouseleave', function(e) {
      closeDisclosures();
    });

    //On click/focus event for toggling options
    $toggle.on('mouseenter focus', function(e) {
      //Close all other menus
      closeDisclosures(true, this);

      var $target = $(e.currentTarget);
      $target.attr('aria-expanded', 'true').addClass('is-clicked');
      checkOffScreen($target);
    });

    //When tabbing through, close dropdown when tabbing out of dropdown
    $('.disclosure__button').on('focusout', function(e) {
      //Close all other menus
      if(!$(e.relatedTarget).hasClass('disclosure__button') || $(e.relatedTarget).hasClass('disclosure__toggle')) {
        closeDisclosures();
      }
    });

    //Mobile toggle logic
    $toggle.on('touchstart', function(e) {
      if (window.PXUTheme.media_queries.medium.matches || !/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
        var $target = $(e.currentTarget);

        closeDisclosures(true, this);

        if(!$target.hasClass('is-clicked')) {
          $target.attr('aria-expanded', 'true').addClass('is-clicked');
          checkOffScreen($target);
        } else {
          $target.attr('aria-expanded', 'false').removeClass('is-clicked');
          $disclosureWrap.removeClass('disclosure--left');
        }
      }
    })

  },
  addImageDimension: function(imageUrl, size) {
    var insertPosition = imageUrl.lastIndexOf(".");
    return imageUrl.substring(0, insertPosition) + size + imageUrl.substring(insertPosition);
  },
  unload: function($target){
    $('[data-disclosure]').off();
    $('[data-disclosure-toggle]').off();
  }
}

window.sliderBlock = {
  select: function(blockId, $parentSection){
    var $blocks = $parentSection.find('.gallery-cell');
    var blockIdsArray = $blocks.map(function() {
      return String($(this).data('block-id'));
    });

    var $slider = $parentSection.find('[data-slider-id]');
    var settings = {
      slideshowTextAnimation: $slider.data('slideshow-text-animation')
    }
    var flkty = $slider.data('flickity');

    $slider.flickity('pausePlayer');

    for(var i = 0; i < blockIdsArray.length; i++){
      if(blockIdsArray[i] === blockId){
        var currentSlide = i;
        if (currentSlide !== flkty.selectedIndex){
          $slider.flickity( 'select', parseInt(currentSlide), false, true);
        }
      }
    }
  },
  deselect: function($parentSection){
    var $slider = $parentSection.find('.flexslider').data('flexslider');
    if($slider) {
      $slider.flickity('unpausePlayer');
    }
  }
}

/*============================================================================
  #Quick shop
==============================================================================*/

var globalQuickShopProduct;

window.quickShop = {
  init: function(){

    //EVENT - click on quick-shop
    $('body').on('click', '.js-quick-shop-link', e => {
      e.preventDefault();

      const $currentTarget = $(e.currentTarget);

      window.productPage
        .loadQuickshop($currentTarget.data('url'))
        .then(data => {
          if (!data) { return; }
          const html = data.html;
          $('.js-quick-shop').html(html.content);

          if (!$('.fancybox-active').length) {
            $.fancybox.open($('.js-quick-shop'), {
              baseClass: `quick-shop__lightbox product-${$currentTarget.data('id')}`,
              hash: false,
              infobar : false,
              toolbar: false,
              loop: false,
              smallBtn : true,
              video: {
                autoStart: false
              },
              touch: false,
              mobile: {
                preventCaptionOverlap: false,
                toolbar: true,
                buttons: [
                  "close"
                ]
              },
              beforeLoad: () => {
                window.productPage.init();
                window.productPage.runOptionSelector($('.js-quick-shop'));
                window.accordion.init();
                videoFeature.setupVideoPlayer();
                productMedia.setupMedia();
                utils.initializeTabs();
                productPage.productSwatches();

                if (Shopify.PaymentButton) {
                  Shopify.PaymentButton.init();
                }
              },
              afterShow: (_e, instance) => {
                // Use unique identifier for the product gallery
                const { src } = instance;
                const $quickshop = $(src).find('.quick-shop');

                $quickshop.addClass('quick-shop--loaded');
                $quickshop.addClass('content-loaded');
              },
              beforeClose: (_e, instance) => {
                // Use unique identifier for the product gallery
                const { src } = instance;
                const $quickshop = $(src).find('.quick-shop');

                $quickshop.removeClass('quick-shop--loaded');
                $quickshop.removeClass('content-loaded');
              }
            });
          }
        }).catch(error => console.error(error))
    });

    $('.swatch_options label').on('click', function() {
      window.quickShop.toggleSwatchImages($(this));
    });
  },
  toggleSwatchImages: function(swatchInput) {
    var swatchImageID = $(swatchInput).data('image');
    var $quickShopElement = $(swatchInput).parents('.thumbnail').find('.image__container img');

    $quickShopElement.attr('src', swatchImageID);
    $quickShopElement.attr('srcset', swatchImageID);
  }
}

/*============================================================================
  #Back to top button
==============================================================================*/

window.back_to_top_button = {
  init() {
    this.el = document.querySelector('[data-back-to-top]');
    this.label = this.el.querySelector('.back-to-top__button-label');
    this.events = new EventHandler();
    this.buttonAnimation = window.animations.transition({ el: this.el });
    this.labelAnimation = window.animations.transition({ el: this.label, state: 'hidden' });
    this.scrollThreshold = 0.3;
    this.events.register(this.el, 'click', () => this._scrollToTop());
    this.events.register(this.el, 'mouseenter', () => this._onHover());
    this.events.register(this.el, 'mouseleave', () => this._onHoverEnd());
    this.events.register(window, 'scroll', debounce(() => this._onScroll(), 100, true));
  },
  get scrollPosition() {
    return window.scrollY / (document.body.offsetHeight - window.innerHeight);
  },
  _onScroll() {
    if (window.PXUTheme.media_queries.medium.matches) return;

    if (this.scrollPosition >= this.scrollThreshold) {
      this.buttonAnimation.animateTo('visible');
    } else {
      this.buttonAnimation.animateTo('hidden');
    }
  },
  _onHover() {
    if (window.PXUTheme.media_queries.mobile_and_tablet.matches) return;
    this.labelAnimation.animateTo('visible', {
      onStart: ({ el }) => {
        // When this function is called, element is `display: block; width: 0;`
        // but the wrapper's scrollWidth is the width we want to transition to
        const { scrollWidth } = el;

        // Add 8px to the width to create padding between the text and the chevron
        // We add this space here because adding padding via CSS causes a 'stepped'
        // animation effect due to the way browsers calculate visible width
        const adjustedScrollWidth = parseInt(scrollWidth, 10) + 8;

        el.style.setProperty('--open-width', `${adjustedScrollWidth}px`);
      },
    });
  },
  _onHoverEnd() {
    if (window.PXUTheme.media_queries.mobile_and_tablet.matches) return;
    this.labelAnimation.animateTo('hidden');
  },
  _scrollToTop() {
    document.activeElement.blur();
    window.scrollTo({
      top: 0,
      behavior: 'smooth',
    });
  }
}

/*============================================================================
  #Newsletter Popup
==============================================================================*/

window.newsletter_popup = {
  init: function(){
    var popup = window.Cookies.get('popup');
    var newsletter_popup_days = parseInt(window.PXUTheme.theme_settings.newsletter_popup_days);
    var cookie_enabled = newsletter_popup_days != 0 ? true : false;
    if (cookie_enabled && popup == 'open') {
      return false;
    } else {
      window.newsletter_popup.open();
    }
    if (cookie_enabled) {
      window.Cookies.set('popup', 'open', { expires: newsletter_popup_days, path: '', domain: '', sameSite: 'None', secure: true });
    }
  },
  open: function(){
    var newsletter_popup_seconds = parseInt(window.PXUTheme.theme_settings.newsletter_popup_seconds);

    if (window.PXUTheme.theme_settings.newsletter_popup_mobile || window.PXUTheme.media_queries.large.matches) {
      setTimeout( function() {
        $.fancybox.open($('.js-newsletter-popup'), {
          baseClass: 'newsletter__lightbox',
          hash: false,
          infobar : false,
          toolbar: false,
          loop: true,
          smallBtn : true,
          mobile: {
            preventCaptionOverlap: false,
            toolbar: true,
            buttons: [
              "close"
            ]
          }
        });
      },
      newsletter_popup_seconds * 1000);
    }
  }
}

/*============================================================================
  #Product media controls
==============================================================================*/

window.productMedia = {
  models: [],
  setupMedia: function() {
    var config = {
      // Default control list
      controls: [
        'zoom-in',
        'zoom-out',
        'fullscreen'
      ],
      focusOnPlay: false
    }

    $($('model-viewer', $('.js-product-gallery, .js-gallery-modal'))).each(function(index, model) {
      model = new Shopify.ModelViewerUI(model, config);
      window.productMedia.models.push(model)
    })

    $('.product-gallery__model model-viewer').on('mousedown',function(){
      window.productMedia.hideModelIcon(this);
    })
  },
  showModelIcon: function(slide) {
    $(slide).find('.button--poster, .model-icon-button-control').show();
  },
  hideModelIcon: function(slide) {
    $(slide).find('.button--poster, .model-icon-button-control').hide();
  }
}

/*============================================================================
  #Plyr setup
==============================================================================*/

window.videoEl = {
  playButtonIcon:'<button type="button" class="plyr__control plyr__control--overlaid" aria-label="Play, {title}" data-plyr="play"><svg class="play-icon-button-control" width="60" height="60" viewBox="0 0 60 60" fill="none" xmlns="http://www.w3.org/2000/svg"><rect width="60" height="60" fill="white"/><path fill-rule="evenodd" clip-rule="evenodd" d="M23 20V40L39 29.4248L23 20Z" fill="#323232"/></svg><span class="plyr__sr-only">Play</span></button>',
  playButton: '<button type="button" class="plyr__controls__item plyr__control" aria-label="Play, {title}" data-plyr="play"><svg class="icon--pressed" role="presentation"><use xlink:href="#plyr-pause"></use></svg><svg class="icon--not-pressed" role="presentation"><use xlink:href="#plyr-play"></use></svg><span class="label--pressed plyr__tooltip" role="tooltip">Pause</span><span class="label--not-pressed plyr__tooltip" role="tooltip">Play</span></button>',
  muteButton: '<button type="button" class="plyr__controls__item plyr__control" aria-label="Mute" data-plyr="mute"><svg class="icon--pressed" role="presentation"><use xlink:href="#plyr-muted"></use></svg><svg class="icon--not-pressed" role="presentation"><use xlink:href="#plyr-volume"></use></svg><span class="label--pressed plyr__tooltip" role="tooltip">Unmute</span><span class="label--not-pressed plyr__tooltip" role="tooltip">Mute</span></button>',
  progressInput: '<div class="plyr__controls__item plyr__progress__container"><div class="plyr__progress"><input data-plyr="seek" type="range" min="0" max="100" step="0.01" value="0" aria-label="Seek"><progress class="plyr__progress__buffer" min="0" max="100" value="0">% buffered</progress><span role="tooltip" class="plyr__tooltip">00:00</span></div></div>',
  volume: '<div class="plyr__controls__item plyr__volume"><input data-plyr="volume" type="range" min="0" max="1" step="0.05" value="1" autocomplete="off" aria-label="Volume"></div>',
  fullscreen: '<button type="button" class="plyr__controls__item plyr__control" data-plyr="fullscreen"><svg class="icon--pressed" role="presentation"><use xlink:href="#plyr-exit-fullscreen"></use></svg><svg class="icon--not-pressed" role="presentation"><use xlink:href="#plyr-enter-fullscreen"></use></svg><span class="label--pressed plyr__tooltip" role="tooltip">Exit fullscreen</span><span class="label--not-pressed plyr__tooltip" role="tooltip">Enter fullscreen</span></button>'
}

window.videoControls = window.videoEl.playButtonIcon + '<div class="plyr__controls">' + window.videoEl.playButton + window.videoEl.progressInput + window.videoEl.muteButton + videoEl.volume + window.videoEl.fullscreen + '</div>';
window.globalVideoPlayers = [];
window.videoPlayers = [];
window.videosInRecommendedProductsPlayer;

window.videoFeature = {
  init: function() {

    this.setupVideoPlayer();
    this.setupRecommendedVideoPlayer();

  },
  setupVideoPlayer: function() {
    var productVideos = document.querySelectorAll('[data-html5-video] video, [data-youtube-video]');

    var setupVideoPlayers = Plyr.setup(productVideos, {
      controls: window.videoControls,
      ratio: this.aspect_ratio,
      fullscreen: {
        enabled: true,
        fallback: true,
        iosNative: true
      },
      storage: {
        enabled: false
      }
    });

    // Moves players into global array so that we can target them for play/pause on global level
    if (window.globalVideoPlayers) {
      $.each(setupVideoPlayers, function(index, player) {
        window.globalVideoPlayers.push(player);
      })
    }

    var videoLooping = $('[data-video-loop]').data('video-loop') || false;
    $.each(setupVideoPlayers, function(index, player) {
      player.loop = videoLooping;
      window.videoPlayers.push(player);
    });

    this.setupListeners();
  },
  setupPlayerForRecentlyViewedProducts: function(video) {

    if (video) {
      var recentlyViewedProductPlayer = new Plyr(video, {
        controls: window.videoControls,
        ratio: this.aspect_ratio,
        fullscreen: {
          enabled: true,
          fallback: true,
          iosNative: true
        },
        storage: {
          enabled: false
        }
      });

      if (window.videoPlayers !== null) {
        window.videoPlayers.push(recentlyViewedProductPlayer);
        this.setupListeners();
      }

    }
  },
  setupRecommendedVideoPlayer: function() {
    var videosInRecommendedProducts = document.querySelectorAll('.product-recommendations [data-html5-video] video, .product-recommendations [data-youtube-video]');

    // Only run Plyr.setup if videosInRecommendedProducts exists
    if (videosInRecommendedProducts.length > 0) {
      window.videosInRecommendedProductsPlayer = Plyr.setup(videosInRecommendedProducts, {
        controls: window.videoControls,
        fullscreen: {
          enabled: true,
          fallback: true,
          iosNative: true
        },
        storage: {
          enabled: false
        }
      });
      if (window.videoPlayers !== null) {
        var combinedArray = window.videoPlayers.concat(window.videosInRecommendedProductsPlayer);
        window.videoPlayers = combinedArray;
      } else {
        window.videoPlayers = videosInRecommendedProductsPlayer;
      }
    }

    this.setupListeners();
  },
  setupListeners: function() {
    // Adds plyr video id to video wrapper
    $.each(window.videoPlayers, function(index, player) {
      var id = player.id || player.media.dataset.plyrVideoId;
      var $video;

      if (player.isHTML5) {
        $video = $(player.elements.wrapper).find('video');
        $video.attr('data-plyr-video-id', id);
      }
    })

    // When a video is playing, pause any other instances
    $.each(window.globalVideoPlayers, function(index, player) {
      player.on('play', function(event) {
        var instance = event.detail.plyr;
        $.each(window.globalVideoPlayers, function(index, player) {
          if (instance.id != player.id ) {
            player.pause();
          }
        })
      })
    })
  },
  enableVideoOnHover: function($thumbnail) {

    var $html5Video = $thumbnail.find('[data-html5-video]');
    var $youtubeVideo = $thumbnail.find('[data-youtube-video]');
    var videoID;

    if ($html5Video.length > 0) {
      videoID = $html5Video.find('[data-plyr-video-id]').data('plyr-video-id');
    } else if ($youtubeVideo.length > 0) {
      videoID = $youtubeVideo.find('iframe').attr('id');
    }

    if (videoID) {
      $.each(window.videoPlayers, function(index, player) {

        if (player.id == videoID || player.media.id == videoID) {
          player.toggleControls(false);
          player.muted = true;
          player.play();
        }
      })
    }
  },
  disableVideoOnHover: function($thumbnail) {
    var $html5Video = $thumbnail.find('[data-html5-video]');
    var $youtubeVideo = $thumbnail.find('[data-youtube-video]');
    var videoID;

    if ($html5Video.length > 0) {
      videoID = $html5Video.find('[data-plyr-video-id]').data('plyr-video-id');
    } else if ($youtubeVideo.length > 0) {
      videoID = $youtubeVideo.find('iframe').attr('id');
    }

    if (videoID) {
      $.each(window.videoPlayers, function(index, player) {
        if (player.id == videoID || player.media.id == videoID) {
          if (player.playing) {
            player.pause();
          }
        }
      })
    }
  }
}



window.psuedoVariants = {
  init(options = {}) {
    this.options = options
    this.setupAllContainers()
    if (!this._resizeBound) {
      this._resizeBound = true
      window.addEventListener('resize', () => this._updateAll())
    }
  },

  setupAllContainers() {
    document.querySelectorAll('.psuedo-variants--container')
      .forEach(container => this.setupContainer(container))
  },

  setupContainer(container) {
    const main = container.closest('.psuedo-variants--container-main')
    const scroller = container.querySelector('.scroller')
    const prevBtn = container.querySelector('.prev-btn')
    const nextBtn = container.querySelector('.next-btn')
    if (!main || !scroller || !prevBtn || !nextBtn) return

    if ('siblingContainer' in container.dataset) {
      this._setupSiblings(main, container, scroller, prevBtn, nextBtn)
    } else if ('tagContainer' in container.dataset) {
      this._setupTagFetch(main, container, scroller, prevBtn, nextBtn)
    }
  },

  _setupSiblings(main, container, scroller, prevBtn, nextBtn) {
    if (!scroller.querySelector('a')) {
      main.classList.remove('active')
      return
    }
    main.classList.add('active')
    this._wireScroll(container, scroller, prevBtn, nextBtn)
    this.updateButtons(container)
  },

  _setupTagFetch(main, container, scroller, prevBtn, nextBtn) {
    const tag = container.dataset.groupTag
    if (!tag) return
    const currentId = container.dataset.currentProduct
    const currentCollection = container.dataset.currentCollection

    scroller.innerHTML = ''
    main.classList.remove('active')

    fetch(`${window.PXUTheme.routes.all_products_collection_url}/${encodeURIComponent(tag)}?view=fetchTaggedProducts`)
      .then(r => r.json())
      .then(data => {
        const seen = new Set([currentId])
        const items = (data.products || []).filter(p => p.image && !seen.has(`${p.id}`))
        if (items.length === 0) return
        main.classList.add('active')
        items.forEach(p => {
          seen.add(`${p.id}`)
          const link = document.createElement('a')
          const coll = currentCollection && p.collections.find(c => c.handle === currentCollection)
          link.href = coll ? `/collections/${coll.handle}/products/${p.handle}` : p.onlineStoreUrl
          link.title = p.title
          const img = document.createElement('img')
          img.loading = 'lazy'
          img.src = p.image
          img.alt = p.title
          link.appendChild(img)
          scroller.appendChild(link)
        })
        this.updateButtons(container)
      })
      .catch(() => {})

    this._wireScroll(container, scroller, prevBtn, nextBtn)
  },

  _wireScroll(container, scroller, prevBtn, nextBtn) {
    const calcScrollAmt = () => {
      const first = scroller.querySelector('a')
      return first ? first.offsetWidth * 1.5 : (this.options.scrollAmount || 200)
    }
    const doScroll = dir => {
      const amt = calcScrollAmt() * (dir < 0 ? -1 : 1)
      scroller.scrollBy({ left: amt, behavior: 'smooth' })
      setTimeout(() => this.updateButtons(container), 300)
    }
    prevBtn.onclick = e => { e.preventDefault(); doScroll(-1) }
    nextBtn.onclick = e => { e.preventDefault(); doScroll(1) }
    scroller.onscroll = () => this.updateButtons(container)
  },

  _updateAll() {
    document.querySelectorAll('.psuedo-variants--container')
      .forEach(container => this.updateButtons(container))
  },

  updateButtons(container) {
    const s = container.querySelector('.scroller')
    const p = container.querySelector('.prev-btn')
    const n = container.querySelector('.next-btn')
    if (!s || !p || !n) return
    const { scrollLeft, scrollWidth, clientWidth } = s
    const overflow = scrollWidth > clientWidth
    p.style.display = n.style.display = overflow ? '' : 'none'
    if (!overflow) return
    p.disabled = scrollLeft <= 0
    n.disabled = scrollLeft >= scrollWidth - clientWidth - 1
  }
}



window.cartAddons = {
  galFlkty: null,
  panel: null,
  panelData: null,
  _cache: null,
  _cacheKey: null,
  _products: [],
  _panelIdx: 0,
  DEBUG: false,
  PRIORITY: {
    team: ['SubCat_Air-Freshener','SubCat_Magnet','SubCat_Lanyard','SubCat_Enamel-Pin','SubCat_Keychain','SubCat_Decal','SubCat_Funko-Pop','SubCat_Mini-Figure','SubCat_Hat','SubCat_Hat-Snapback','SubCat_Hat-Beanie','SubCat_Hat-Bucket','SubCat_Scarf','SubCat_Poster'],
    adult_footwear: ['SubCat_Grip-Socks','SubCat_Shin-Guards','SubCat_Sock-Tape','SubCat_Cleat-Bag','SubCat_Sackpack'],
    youth_footwear: ['SubCat_Shin-Guards','SubCat_Soccer-Socks','SubCat_Ball-Mini','SubCat_Water-Bottle','SubCat_Cleat-Bag','SubCat_Sock-Tape','SubCat_Slides'],
    goalkeeper: ['SubCat_Glove-Wash','SubCat_Grip-Spray','SubCat_GK-Pants','SubCat_GK-Shorts','SubCat_GK-Padded','SubCat_Grip-Socks','SubCat_Shin-Guards','SubCat_Ball-Mini','SubCat_Sock-Tape'],
    soccer_ball: ['SubCat_Ball-Pump','SubCat_Ball-Bag','SubCat_Ball-Mini'],
    shin_guards: ['SubCat_Sock-Tape','SubCat_Grip-Socks','SubCat_Soccer-Socks'],
    socks: ['SubCat_Shin-Guards','SubCat_Sock-Tape','SubCat_Slides','SubCat_Ball-Mini']
  },
  _log(...args) {
    if (this.DEBUG) console.log('[Addons]', ...args)
  },
  init() {
    this.panel = document.querySelector('[data-addons-panel]')
    if (!this.panel) return
    this.panel.addEventListener('click', (e) => e.stopPropagation())
    this._bindPanelBack()
    this._bindPanelAdd()
    this._bindPanelNav()
    this._listenCartUpdate()
    this._load()
  },

  _root() { return document.querySelector('[data-cart-addons]') },

  _formatMoney(cents) {
    const fmt = document.body.dataset.moneyFormat
    return (window.Shopify?.formatMoney && fmt) ? window.Shopify.formatMoney(cents, fmt) : '$' + (cents / 100).toFixed(2)
  },

  _tmpl(id) {
    const t = document.getElementById(id)
    if (!t) return null
    const frag = t.content.cloneNode(true)
    return frag.children.length === 1 ? frag.firstElementChild : frag
  },

  _load() {
    const root = this._root()
    if (!root) return
    const limit = parseInt(root.dataset.limit) || 6
    const excluded = root.dataset.excludedIds || ''
    const context = root.dataset.cartContext || 'general'
    const brands = decodeURIComponent(root.dataset.brands || '')
    const key = [root.dataset.pool, root.dataset.sources, excluded, context, brands].join('|')
    if (this._cacheKey === key && this._cache) { this._render(this._cache, root, limit); return }
    this._fetchProducts({ limit, excluded, context, brands, root }).then(products => {
      this._cacheKey = key; this._cache = products; this._render(products, root, limit)
    })
  },

  async _fetchProducts({ limit, excluded, context, brands, root }) {
    this._log('[Addons] Context:', context, '| Limit:', limit)
    this._log('[Addons] Sources:', decodeURIComponent(root?.dataset.sources || ''))
   this._log('[Addons] Brands:', brands)

    const pool = root?.dataset.pool
    const exArr = excluded ? excluded.split(',').map(id => id.trim()).filter(Boolean) : []
    const brandsArr = brands ? brands.replace(/\+/g, ' ').split('|').filter(Boolean) : []
    const collected = []

    const sourcesRaw = decodeURIComponent(root?.dataset.sources || '').split('|').filter(Boolean)
    const sources = sourcesRaw.map(s => {
      const [kind, ...rest] = s.split(':')
      return { kind, val: rest.join(':').replace(/\+/g, ' ') }
    })

    const buildUrl = (filters) => {
      if (!pool) return null
      const params = new URLSearchParams()
      params.append('view', 'addons-json')
      params.append('filter.v.availability', '1')
      for (const [k, vals] of Object.entries(filters)) {
        ;(Array.isArray(vals) ? vals : [vals]).forEach(v => { if (v) params.append(k, v) })
      }
      return `/collections/${pool}?${params.toString()}`
    }

    const fetchFiltered = async (filters) => {
      const url = buildUrl(filters)
      if (!url) return []
      const start = performance.now()
      try {
        const r = await fetch(url)
        if (!r.ok) return []
        const data = await r.json()
        const results = (data.products || []).filter(p => p.available && !exArr.includes(String(p.id)))
        this._log(`[Addons] ← ${results.length} products in ${Math.round(performance.now() - start)}ms`, url)
        return results
      } catch(e) { this._log('[Addons] Fetch error:', e); return [] }
    }

    const priorityList = this.PRIORITY[context] || this.PRIORITY.team
    const ageFilter = context === 'youth_footwear' ? 'AgeGroup_Youth' : context === 'adult_footwear' ? 'AgeGroup_Adult' : null
    const isFootwear = context.includes('footwear')

    const filterAge = (products) => {
      if (!ageFilter) return products
      return products.filter(p => !p.age_group || p.age_group === ageFilter)
    }

    const SUBCAT_TO_TYPE = {
      'SubCat_Air-Freshener': 'Air Freshener',
      'SubCat_Magnet': 'Accessories',
      'SubCat_Lanyard': 'Accessories',
      'SubCat_Enamel-Pin': 'Enamel Pin',
      'SubCat_Keychain': 'Accessories',
      'SubCat_Decal': 'Decal / Sticker',
      'SubCat_Funko-Pop': 'Soccer Collectibles',
      'SubCat_Mini-Figure': 'Mini Figures',
      'SubCat_Hat': 'Hats',
      'SubCat_Hat-Snapback': 'Hats',
      'SubCat_Hat-Beanie': 'Hats',
      'SubCat_Hat-Bucket': 'Hats',
      'SubCat_Scarf': 'Scarves',
      'SubCat_Poster': 'Posters',
      'SubCat_Grip-Socks': 'Socks',
      'SubCat_Soccer-Socks': 'Socks',
      'SubCat_Shin-Guards': 'Shin Guards',
      'SubCat_Ball-Mini': 'Balls',
      'SubCat_Ball-Pump': 'Accessories',
      'SubCat_Ball-Bag': 'Bags',
      'SubCat_Cleat-Bag': 'Bags',
      'SubCat_Sackpack': 'Bags',
      'SubCat_Water-Bottle': 'Water Bottles',
      'SubCat_Sock-Tape': 'Accessories',
      'SubCat_Slides': 'Footwear',
      'SubCat_Glove-Wash': 'Accessories',
      'SubCat_Grip-Spray': 'Accessories',
      'SubCat_GK-Pants': 'Pants',
      'SubCat_GK-Shorts': 'Shorts',
      'SubCat_GK-Padded': 'Compression'
    }

    const buildBatchJobs = (subcats, extraFilters) => {
      const typeMap = {}
      subcats.forEach(sc => {
        const type = SUBCAT_TO_TYPE[sc]
        if (!type) return
        if (!typeMap[type]) typeMap[type] = { type, subcats: [], filters: { ...extraFilters, 'filter.p.product_type': type } }
        typeMap[type].subcats.push(sc)
      })
      return Object.values(typeMap)
    }

    const pickMatch = (results, subcat) => {
      if (isFootwear && brandsArr.length) {
        const brandMatch = results.find(p =>
          p.sub_category === subcat &&
          !collected.find(c => c.id === p.id) &&
          (p.tags || []).some(t => brandsArr.includes(t))
        )
        if (brandMatch) return brandMatch
      }
      return results.find(p => p.sub_category === subcat && !collected.find(c => c.id === p.id))
    }

    if (context === 'team') {
      const teamSources = sources.filter(s => s.kind === 'club' || s.kind === 'country')
      if (teamSources.length > 0) {
        const perTeam = Math.max(2, Math.ceil(limit / teamSources.length))

        for (const src of teamSources) {
          if (collected.length >= limit) break
          const filterKey = src.kind === 'club' ? 'filter.p.m.custom.club_filter' : 'filter.p.m.custom.country_filter'
          const jobs = buildBatchJobs(priorityList, { [filterKey]: src.val })

          this._log(`[Addons] Team "${src.val}": ${jobs.length} parallel fetches`)
          const batchResults = await Promise.all(jobs.map(j => fetchFiltered(j.filters)))
          this._log(`[Addons] Team "${src.val}" results:`, batchResults.map((r, i) => `${jobs[i].subcats.join('/')}: ${r.length}`))

          let teamAdded = 0
          for (const subcat of priorityList) {
            if (teamAdded >= perTeam || collected.length >= limit) break
            const jobIdx = jobs.findIndex(j => j.subcats.includes(subcat))
            if (jobIdx === -1) continue
            const match = pickMatch(batchResults[jobIdx] || [], subcat)
            if (match) { collected.push(match); teamAdded++ }
          }
          this._log(`[Addons] Team "${src.val}" picked ${teamAdded} products`)
        }
      }

    } else if (context !== 'general') {
      const jobs = buildBatchJobs(priorityList, {})

      this._log(`[Addons] ${context}: ${jobs.length} parallel fetches`)
      const batchResults = await Promise.all(jobs.map(j => fetchFiltered(j.filters)))
      this._log(`[Addons] ${context} results:`, batchResults.map((r, i) => `${jobs[i].subcats.join('/')}: ${r.length}`))

      for (const subcat of priorityList) {
        if (collected.length >= limit) break
        const jobIdx = jobs.findIndex(j => j.subcats.includes(subcat))
        if (jobIdx === -1) continue
        const results = filterAge(batchResults[jobIdx] || [])
        const match = pickMatch(results, subcat)
        if (match) collected.push(match)
      }
    }

    // Fallback — fill remaining slots
    if (collected.length < limit) {
      this._log(`[Addons] Fallback: need ${limit - collected.length} more`)
      const fallback = await fetchFiltered({})
      const filtered = filterAge(fallback).filter(p => !collected.find(c => c.id === p.id))
      const sorted = filtered.sort((a, b) => {
        const aPri = priorityList.indexOf(a.sub_category)
        const bPri = priorityList.indexOf(b.sub_category)
        return (aPri === -1 ? 999 : aPri) - (bPri === -1 ? 999 : bPri)
      })
      for (const p of sorted) {
        if (collected.length >= limit) break
        collected.push(p)
      }
    }

    this._log('[Addons] Final products:', collected.map(p => `${p.title} (${p.sub_category})`))
    this._log(`[Addons] Total: ${collected.length}/${limit}`)
    return collected
  },

  _bindDrag(slider) {
    let startY = 0, startScroll = 0, isDragging = false, moved = false
    const onStart = (e) => { isDragging = true; moved = false; startY = e.type === 'touchstart' ? e.touches[0].clientY : e.clientY; startScroll = slider.scrollTop; slider.style.scrollBehavior = 'auto' }
    const onMove = (e) => {
      if (!isDragging) return
      const y = e.type === 'touchmove' ? e.touches[0].clientY : e.clientY
      if (Math.abs(y - startY) > 5 && !moved) { moved = true; slider.style.cursor = 'grabbing'; slider.classList.add('is-dragging') }
      if (moved) slider.scrollTop = startScroll - (y - startY)
    }
    const onEnd = () => { isDragging = false; slider.style.scrollBehavior = 'smooth'; slider.style.cursor = 'grab'; setTimeout(() => slider.classList.remove('is-dragging'), 50) }
    slider.style.cursor = 'grab'
    slider.addEventListener('mousedown', onStart); slider.addEventListener('mousemove', onMove); slider.addEventListener('mouseup', onEnd); slider.addEventListener('mouseleave', onEnd)
    slider.addEventListener('touchstart', onStart, { passive: true }); slider.addEventListener('touchmove', onMove, { passive: true }); slider.addEventListener('touchend', onEnd)
  },

  _render(products, root, limit) {
    const loader = root.querySelector('.cart-addons__loader'), slider = root.querySelector('[data-addons-slider]')
    if (!slider) return
    if (loader) loader.style.display = 'none'

    // Parse pinned products
    let pinned = []
    const pinnedEl = root.querySelector('[data-pinned-products]')
    if (pinnedEl) {
      try {
        const parsed = JSON.parse(pinnedEl.textContent)
        const exArr = (root.dataset.excludedIds || '').split(',').map(id => id.trim()).filter(Boolean)
        pinned = parsed.filter(p => p.available && !exArr.includes(String(p.id)) && !products.find(c => c.id === p.id))
      } catch(e) {}
    }

    if (!products?.length && !pinned.length) { root.style.display = 'none'; return }

    // Sort only fetched products, then append pinned at end
    const sorted = this._sortByPriorityTags(products, root.dataset.priorityTags)
    this._products = [...sorted, ...pinned]
    slider.innerHTML = ''
    this._products.forEach(p => {
      const card = this._tmpl('tmpl-addon-card')
      if (!card) return
      const v = p.variants?.[0], price = this._formatMoney(v?.price || 0)
      const src = p.images?.[0]?.src ? p.images[0].src.replace(/(\.[^.]+)$/, '_300x300$1') : ''
      const img = card.querySelector('.cart-addons__card-img'), title = card.querySelector('.cart-addons__title')
      const priceBadge = card.querySelector('[data-addon-price]')
      const addLabel = card.querySelector('[data-addon-add-label]')
      if (img && src) { img.src = src; img.alt = p.title } else if (img) img.remove()
      if (title) { title.textContent = p.title; title.href = '/products/' + p.handle }
      if (priceBadge) priceBadge.textContent = price.replace(/\s+/g, '')
      if (addLabel) addLabel.textContent = 'Add ' + price.replace(/\s+/g, '')
      card.dataset.addonProduct = JSON.stringify({ id: p.id, title: p.title, handle: p.handle, vendor: p.vendor || '', price, description: p.description || '', images: (p.images || []).slice(0, 6).map(i => typeof i === 'string' ? i : i.src), variants: p.variants || [], options: p.options || [], tags: p.tags || [] })
      slider.appendChild(card)
    })
    this._bindTriggers(root)
    this._bindListNav(root, slider)
    this._bindDrag(slider)
    this._nudgeScroll(slider)
    this._bindScrollbar(slider)
  },

  _sortByPriorityTags(products, rawTags) {
    if (!rawTags) return products
    const tags = decodeURIComponent(rawTags).split(',').map(t => t.trim().toLowerCase()).filter(Boolean)
    if (!tags.length) return products
    return [...products].sort((a, b) => {
      const aMatch = (a.tags || []).some(t => tags.includes((typeof t === 'string' ? t : '').toLowerCase()))
      const bMatch = (b.tags || []).some(t => tags.includes((typeof t === 'string' ? t : '').toLowerCase()))
      if (aMatch && !bMatch) return -1
      if (!aMatch && bMatch) return 1
      return 0
    })
  },

  _bindListNav(root, slider) {
    const upBtn = root.querySelector('[data-addons-up]'), downBtn = root.querySelector('[data-addons-down]'), scrollAmt = 72
    const updateBtns = () => {
      const max = slider.scrollHeight - slider.clientHeight
      if (max <= 0) { if (upBtn) { upBtn.disabled = true; upBtn.classList.add('is-disabled') } if (downBtn) { downBtn.disabled = true; downBtn.classList.add('is-disabled') } return }
      if (upBtn) { upBtn.disabled = slider.scrollTop <= 1; upBtn.classList.toggle('is-disabled', slider.scrollTop <= 1) }
      if (downBtn) { downBtn.disabled = slider.scrollTop >= max - 1; downBtn.classList.toggle('is-disabled', slider.scrollTop >= max - 1) }
    }
    if (upBtn) upBtn.addEventListener('click', (e) => { e.preventDefault(); e.stopPropagation(); slider.scrollBy({ top: -scrollAmt, behavior: 'smooth' }) })
    if (downBtn) downBtn.addEventListener('click', (e) => { e.preventDefault(); e.stopPropagation(); slider.scrollBy({ top: scrollAmt, behavior: 'smooth' }) })
    slider.addEventListener('scroll', updateBtns, { passive: true }); updateBtns()
  },

  _nudgeScroll(slider) {
    if (slider.scrollHeight <= slider.clientHeight) return
    setTimeout(() => { slider.scrollTo({ top: 40, behavior: 'smooth' }); setTimeout(() => slider.scrollTo({ top: 0, behavior: 'smooth' }), 600) }, 1000)
  },

  _bindScrollbar(slider) {
    const bar = slider.parentElement?.querySelector('.cart-addons__scrollbar-thumb')
    if (!bar) return
    const track = bar.parentElement
    const update = () => {
      const max = slider.scrollHeight - slider.clientHeight
      if (max <= 0) { track.style.display = 'none'; return }
      bar.style.top = ((slider.scrollTop / max) * (track.offsetHeight - bar.offsetHeight)) + 'px'
    }
    slider.addEventListener('scroll', update, { passive: true }); update()
  },

  _bindTriggers(root) {
    const quickSingle = root.dataset.quickSingle === 'true'
    root.querySelectorAll('[data-addon-trigger]').forEach((btn, i) => {
      btn.addEventListener('click', (e) => {
        e.preventDefault(); e.stopPropagation()
        const card = btn.closest('[data-addon-product]')
        if (!card) return
        try {
          const data = JSON.parse(card.dataset.addonProduct)
          const variants = data.variants || [], options = data.options || []
          const hasOpts = options.length > 1 || options[0]?.name !== 'Title'
          const availableVariants = variants.filter(v => v.available)
          if (quickSingle && (!hasOpts || availableVariants.length <= 1) && availableVariants[0]) { this._quickAdd(availableVariants[0].id, btn) }
          else { this._panelIdx = i; this._openPanel(data) }
        } catch(err) {}
      })
    })
  },

  _quickAdd(variantId, btn) {
    const origHtml = btn.innerHTML
    const context = this._root()?.dataset.cartContext || 'general'
    btn.disabled = true
    btn.innerHTML = '<span class="cart-addons-panel__spinner" style="width:12px;height:12px;border-width:1.5px"></span>'
    $.ajax({
      url: '/cart/add.js', dataType: 'json', type: 'post', contentType: 'application/json',
      data: JSON.stringify({ items: [{ id: parseInt(variantId), quantity: 1, properties: { '__addon_source': 'cart_drawer', '__addon_context': context } }] }),
      success: () => { $.getJSON('/cart.js', (cart) => { window.refreshCart(cart) }) },
      error: () => { btn.innerHTML = origHtml; btn.disabled = false },
      complete: () => { btn.disabled = false }
    })
  },

  _openPanel(data) {
    if (!this.panel) return
    this.panelData = data; this.panel.innerHTML = ''
    if (this.galFlkty) { try { this.galFlkty.destroy() } catch(e) {}; this.galFlkty = null }
    const variants = data.variants || [], options = data.options || []
    const hasOpts = options.length > 1 || options[0]?.name !== 'Title'
    const availableVariants = variants.filter(v => v.available)
    const showOpts = hasOpts && availableVariants.length > 1
    const tpl = this._tmpl('tmpl-addon-panel')
    if (!tpl) return
    this.panel.appendChild(tpl)

    const titleEl = this.panel.querySelector('.cart-addons-panel__title'), vendorEl = this.panel.querySelector('.cart-addons-panel__vendor')
    const priceEl = this.panel.querySelector('.cart-addons-panel__price'), pdpEl = this.panel.querySelector('.cart-addons-panel__pdp'), addBtn = this.panel.querySelector('[data-panel-add]')
    if (vendorEl && data.vendor) vendorEl.textContent = data.vendor
    if (titleEl) titleEl.textContent = data.title
    if (priceEl) priceEl.textContent = data.price
    if (pdpEl) pdpEl.href = '/products/' + data.handle

    const gallery = this.panel.querySelector('[data-panel-gallery]'), thumbsWrap = this.panel.querySelector('[data-panel-thumbs]')
    ;(data.images || []).forEach((img, i) => {
      const src = typeof img === 'string' ? img : img.src
      if (!src) return
      const el = this._tmpl('tmpl-addon-panel-img')
      if (el) { el.src = src.replace(/(\.[^.]+)$/, '_600x600$1'); el.alt = data.title; gallery?.appendChild(el) }
      const thumb = this._tmpl('tmpl-addon-panel-thumb')
      if (thumb) { thumb.src = src.replace(/(\.[^.]+)$/, '_100x100$1'); thumb.alt = data.title; if (i === 0) thumb.classList.add('is-active'); thumbsWrap?.appendChild(thumb) }
    })
    if (gallery && typeof Flickity !== 'undefined' && data.images?.length > 1) {
      this.galFlkty = new Flickity(gallery, { cellAlign: 'left', contain: true, prevNextButtons: false, pageDots: false, draggable: true })
      const thumbs = thumbsWrap?.querySelectorAll('.cart-addons-panel__thumb')
      this.galFlkty.on('change', (idx) => { thumbs?.forEach((t, i) => t.classList.toggle('is-active', i === idx)) })
      thumbs?.forEach((t, i) => { t.addEventListener('click', () => this.galFlkty.select(i)) })
    }

    const descEl = this.panel.querySelector('.cart-addons-panel__desc-body')
    if (descEl && data.description) descEl.innerHTML = data.description
    else this.panel.querySelector('.cart-addons-panel__desc')?.remove()

    const optsWrap = this.panel.querySelector('.cart-addons-panel__options-wrap')
    if (showOpts && optsWrap) {
      options.forEach((opt, idx) => {
        const group = this._tmpl('tmpl-addon-option-group')
        if (!group) return
        const label = group.querySelector('.cart-addons-panel__option-label'), cont = group.querySelector('.cart-addons-panel__options')
        if (label) label.textContent = opt.name
        if (cont) cont.dataset.optionIdx = idx
        ;[...new Set(variants.map(v => v.options?.[idx]).filter(Boolean))].forEach(val => {
          const btn = this._tmpl('tmpl-addon-option-btn')
          if (!btn) return
          const avail = variants.some(v => v.options?.[idx] === val && v.available)
          btn.textContent = val; btn.dataset.optValue = val
          if (!avail) { btn.classList.add('is-disabled'); btn.disabled = true }
          cont?.appendChild(btn)
        })
        optsWrap.appendChild(group)
      })
    } else if (optsWrap) { optsWrap.remove() }

    if (addBtn) {
      addBtn.dataset.productId = data.id
      if (!showOpts && availableVariants[0]) { addBtn.dataset.variantId = availableVariants[0].id; addBtn.disabled = false }
      else { addBtn.disabled = true }
    }
    this.panel.classList.add('is-open')
    if (showOpts) {
      this._bindOptionSelect()
      this.panel.querySelectorAll('[data-option-idx]').forEach(g => {
        const btns = g.querySelectorAll('.cart-addons-panel__opt:not(.is-disabled)')
        if (btns.length === 1) btns[0].classList.add('is-selected')
      })
      this._resolveVariant()
    }
  },

  _bindOptionSelect() {
    if (!this.panel) return
    this.panel.querySelectorAll('.cart-addons-panel__opt').forEach(btn => {
      btn.addEventListener('click', () => {
        btn.closest('[data-option-idx]')?.querySelectorAll('.cart-addons-panel__opt').forEach(b => b.classList.remove('is-selected'))
        btn.classList.add('is-selected'); this._resolveVariant()
      })
    })
  },

  _resolveVariant() {
    if (!this.panel || !this.panelData) return
    const variants = this.panelData.variants || [], options = this.panelData.options || []
    const addBtn = this.panel.querySelector('[data-panel-add]')
    if (!addBtn) return
    const selected = {}
    this.panel.querySelectorAll('[data-option-idx]').forEach(g => { const sel = g.querySelector('.is-selected'); if (sel) selected[parseInt(g.dataset.optionIdx)] = sel.dataset.optValue })
    if (!options.every((_, i) => selected[i] !== undefined)) { addBtn.disabled = true; return }
    const match = variants.find(v => options.every((_, i) => v.options?.[i] === selected[i]))
    addBtn.disabled = !match || !match.available; addBtn.dataset.variantId = match ? match.id : ''
  },

  _bindPanelBack() { this.panel.addEventListener('click', (e) => { if (e.target.closest('[data-panel-back]')) this.panel.classList.remove('is-open') }) },

  _bindPanelNav() {
    this.panel.addEventListener('click', (e) => {
      if (e.target.closest('[data-panel-prev]') && this._panelIdx > 0) { this._panelIdx--; this._openPanel(this._products[this._panelIdx]) }
      if (e.target.closest('[data-panel-next]') && this._panelIdx < this._products.length - 1) { this._panelIdx++; this._openPanel(this._products[this._panelIdx]) }
    })
  },

  _bindPanelAdd() {
    this.panel.addEventListener('click', (e) => {
      const btn = e.target.closest('[data-panel-add]')
      if (!btn || btn.disabled) return
      const variantId = btn.dataset.variantId
      if (!variantId) return
      const context = this._root()?.dataset.cartContext || 'general'
      btn.classList.add('is-loading'); btn.innerHTML = '<span class="cart-addons-panel__spinner"></span> Adding...'
      $.ajax({
        url: '/cart/add.js', dataType: 'json', type: 'post', contentType: 'application/json',
        data: JSON.stringify({ items: [{ id: parseInt(variantId), quantity: 1, properties: { '__addon_source': 'cart_drawer', '__addon_context': context } }] }),
        success: () => { $.getJSON('/cart.js', (cart) => { this.panel.classList.remove('is-open'); window.refreshCart(cart) }) },
        error: () => { btn.textContent = 'Error — try again' },
        complete: () => { btn.classList.remove('is-loading') }
      })
    })
  },

  _listenCartUpdate() {
    document.addEventListener('cart:drawer:updated', () => { this._cache = null; this._cacheKey = null; setTimeout(() => this._load(), 300) })
  }
}

document.addEventListener('DOMContentLoaded', () => {
  const tryInit = () => {
    if (!document.querySelector('[data-addons-panel]') || !document.getElementById('tmpl-addon-card')) { setTimeout(tryInit, 500); return }
    window.cartAddons.init()
  }
  if (window.lazyBlocker) {
    const origRestore = window.lazyBlocker.restore
    window.lazyBlocker.restore = function() { origRestore(); setTimeout(tryInit, 100) }
    if (document.querySelector('[data-addons-panel]')) tryInit()
  } else { tryInit() }
})